import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { useReducer, createContext, useContext, createElement, useState, useEffect, useRef, forwardRef, useLayoutEffect } from 'react';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { RestClient } from 'frontend-restclient';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash.clonedeep';
import classNames from 'classnames';
import Snackbar from '@andes/snackbar';
import { Image } from 'nordic/image';
import { Message, MessageActions } from '@andes/message';
import Modal, { Modal as Modal$1 } from '@andes/modal';
import Button, { Button as Button$1, ButtonText } from '@andes/button';
import warning from 'warning';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import AndesForm from '@andes/form';
import { Dropdown, DropdownGroup, DropdownItem } from '@andes/dropdown';
import Tooltip from '@andes/tooltip';
import merge from 'lodash/merge';
import { CardContent, CardHeader, CardFooter, Card } from '@andes/card';
import Close24 from '@andes/icons/Close20';
import { Pill } from '@andes/badge';
import { Typography } from '@andes/typography';
import BottomSheet from '@andes/bottom-sheet';
import AndesCoachMark from '@andes/coach-marks';

const actions = {
  CANCEL: 'CANCEL',
  EDIT: 'EDIT',
  FETCH_DROPDOWN_INIT: 'FETCH_DROPDOWN_INIT',
  FETCH_DROPDOWN_FINISH: 'FETCH_DROPDOWN_FINISH',
  FETCH_DROPDOWN_ERROR: 'FETCH_DROPDOWN_ERROR',
  SUBMIT_INIT: 'SUBMIT_INIT',
  SUBMIT_FINISH: 'SUBMIT_FINISH',
  SUBMIT_ERROR: 'SUBMIT_ERROR',
  CLEAN_INPUTS: 'CLEAN_INPUTS',
  CLEAN_ALL_INPUTS: 'CLEAN_ALL_INPUTS',
  CHECK_INPUTS_SELECTED: 'CHECK_INPUTS_SELECTED',
  GET_FIRST_INPUT: 'GET_FIRST_INPUT',
  BOTTOM_SHEET_ACTION: 'BOTTOM_SHEET_ACTION',
  RESET_ERROR: 'RESET_ERROR',
  UPDATE_INITIAL: 'UPDATE_INITIAL',
  SUBMIT_FORM: 'SUBMIT_FORM',
  SELECT_DROPDOWN: 'SELECT_DROPDOWN',
  AUTO_OPEN_MODAL_ACTION: 'AUTO_OPEN_MODAL_ACTION'
};
const BRAND = 'BRAND';
const canSelect = item => !item.selected_option && item.options && item.options.length > 0;
const setSelectedDropdown = dropdowns => dropdowns.find(canSelect);
const setSelectedDropdownById = (dropdowns, id) => dropdowns.find(item => item.id === id || canSelect(item));
const reducer = (state, action) => {
  switch (action.type) {
    case actions.UPDATE_INITIAL:
      {
        var _action$initialState, _action$initialState2;
        const newCompleteInputs = (_action$initialState = action.initialState) === null || _action$initialState === void 0 || (_action$initialState = _action$initialState.modal) === null || _action$initialState === void 0 || (_action$initialState = _action$initialState.form) === null || _action$initialState === void 0 ? void 0 : _action$initialState.components.map(item => !!item.selected_option).reduce((previous, current) => previous && current);
        return _objectSpread(_objectSpread(_objectSpread({}, state), action.initialState), {}, {
          submitButton: action.initialState.completedInputs,
          completedInputs: newCompleteInputs,
          selectedDropdown: ((_action$initialState2 = action.initialState) === null || _action$initialState2 === void 0 || (_action$initialState2 = _action$initialState2.modal) === null || _action$initialState2 === void 0 || (_action$initialState2 = _action$initialState2.form) === null || _action$initialState2 === void 0 ? void 0 : _action$initialState2.components[0]) || null
        });
      }
    case actions.FETCH_DROPDOWN_INIT:
      {
        var _action$payload, _action$payload2;
        return _objectSpread(_objectSpread({}, state), {}, {
          modal: _objectSpread(_objectSpread({}, state.modal), {}, {
            form: _objectSpread(_objectSpread({}, state.modal.form), {}, {
              components: action === null || action === void 0 || (_action$payload = action.payload) === null || _action$payload === void 0 || (_action$payload = _action$payload.modal) === null || _action$payload === void 0 || (_action$payload = _action$payload.form) === null || _action$payload === void 0 ? void 0 : _action$payload.components
            })
          }),
          completedInputs: action === null || action === void 0 || (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.completedInputs,
          data: action.payload,
          loading: true,
          error: false
        });
      }
    case actions.SUBMIT_FORM:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          submitButton: action.payload
        });
      }
    case actions.GET_FIRST_INPUT:
      {
        const updatedComponents = state.modal.form.components.map((item, index) => {
          if (index === 0) {
            return _objectSpread(_objectSpread({}, item), {}, {
              options: action.payload.data.search_values
            });
          }
          return item;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          modal: _objectSpread(_objectSpread({}, state.modal), {}, {
            form: _objectSpread(_objectSpread({}, state.modal.form), {}, {
              components: updatedComponents
            })
          })
        });
      }
    case actions.FETCH_DROPDOWN_FINISH:
      {
        const updateInputs = state.modal.form.components.map(item => {
          if (item.id === action.id) {
            return _objectSpread(_objectSpread({}, item), {}, {
              selected_option: action.optionValue
            });
          }
          if (item.id === action.payload.data.id) {
            return _objectSpread(_objectSpread({}, item), {}, {
              options: action.payload.data.search_values
            });
          }
          return item;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          modal: _objectSpread(_objectSpread({}, state.modal), {}, {
            form: _objectSpread(_objectSpread({}, state.modal.form), {}, {
              components: updateInputs
            })
          }),
          loading: false
        });
      }
    case actions.FETCH_DROPDOWN_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: state.modal.form.error_message,
        loading: false
      });
    case actions.SUBMIT_INIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.payload,
        loading: true
      });
    case actions.SUBMIT_FINISH:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.payload,
        loading: false
      });
    case actions.SUBMIT_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: action.payload,
        loading: false
      });
    case actions.BOTTOM_SHEET_ACTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpenForm: action.payload,
        selectedDropdown: setSelectedDropdown(state.modal.form.components)
      });
    case actions.CLEAN_INPUTS:
      {
        const cleanInputs = state.modal.form.components.map((item, index) => {
          if (index < state.modal.form.components.indexOf(state.modal.form.components.find(input => input.id === action.id))) {
            return item;
          }
          if (item.id === action.id) {
            return item;
          }
          return _objectSpread(_objectSpread({}, item), {}, {
            selected_option: null,
            options: []
          });
        });
        state.modal.form.components = cleanInputs;
        state.completedInputs = false;
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: false
        });
      }
    case actions.CLEAN_ALL_INPUTS:
      {
        const cleanAllInputs = state.modal.form.components.map(item => {
          if (item.id === BRAND) {
            return _objectSpread(_objectSpread({}, item), {}, {
              selected_option: null
            });
          }
          return _objectSpread(_objectSpread({}, item), {}, {
            selected_option: null,
            options: []
          });
        });
        state.modal.form.components = cleanAllInputs;
        state.completedInputs = false;
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: false
        });
      }
    case actions.CHECK_INPUTS_SELECTED:
      {
        state.modal.form.components = state.modal.form.components.map(item => {
          if (item.id === action.id) {
            item.selected_option = action.optionValue;
            return item;
          }
          return item;
        });
        const completedInputs = state.modal.form.components.map(item => item.required ? !!item.selected_option : true).reduce((previous, current) => previous && current);
        return _objectSpread(_objectSpread({}, state), {}, {
          submitButton: completedInputs,
          completedInputs,
          selectedDropdown: setSelectedDropdown(state.modal.form.components)
        });
      }
    case actions.RESET_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          error: false
        });
      }
    case actions.SELECT_DROPDOWN:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedDropdown: setSelectedDropdownById(state.modal.form.components, action.payload)
        });
      }
    case actions.AUTO_OPEN_MODAL_ACTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        modal: _objectSpread(_objectSpread({}, state.modal), {}, {
          open_modal: action.payload
        })
      });
    default:
      return state;
  }
};

const restclient = RestClient({
  baseURL: '/',
  timeout: 5000
});
class Service {}
_defineProperty(Service, "getInputsCompats", (url, params) => restclient.get("".concat(url), {
  params
}).then(response => response));

const {
  CANCEL,
  EDIT,
  SUBMIT_INIT,
  SUBMIT_FINISH,
  SUBMIT_ERROR,
  FETCH_DROPDOWN_INIT,
  FETCH_DROPDOWN_FINISH,
  FETCH_DROPDOWN_ERROR,
  CLEAN_INPUTS,
  CLEAN_ALL_INPUTS,
  CHECK_INPUTS_SELECTED,
  BOTTOM_SHEET_ACTION,
  RESET_ERROR,
  GET_FIRST_INPUT,
  UPDATE_INITIAL,
  SUBMIT_FORM,
  SELECT_DROPDOWN,
  AUTO_OPEN_MODAL_ACTION
} = actions;
const StateContext = /*#__PURE__*/createContext({});
const StateProvider = _ref => {
  var _initialState$modal, _initialState$modal2;
  let {
    initialState,
    children,
    onRemove = () => {},
    onSubmitForm = () => {},
    isMobile = false
  } = _ref;
  initialState.completedInputs = initialState === null || initialState === void 0 || (_initialState$modal = initialState.modal) === null || _initialState$modal === void 0 || (_initialState$modal = _initialState$modal.form) === null || _initialState$modal === void 0 ? void 0 : _initialState$modal.components.map(item => !!item.selected_option).reduce((previous, current) => previous && current);
  initialState.submitButton = initialState.completedInputs;
  initialState.isMobile = isMobile;
  initialState.selectedDropdown = (initialState === null || initialState === void 0 || (_initialState$modal2 = initialState.modal) === null || _initialState$modal2 === void 0 || (_initialState$modal2 = _initialState$modal2.form) === null || _initialState$modal2 === void 0 ? void 0 : _initialState$modal2.components[0]) || null;
  const [state, dispatch] = useReducer(reducer, _objectSpread({}, initialState));
  const actionButtonForm = value => {
    dispatch({
      type: SUBMIT_FORM,
      payload: value
    });
  };
  const onCancelAction = () => {
    dispatch({
      type: CANCEL,
      payload: state
    });
  };
  const onEditAction = () => {
    dispatch({
      type: EDIT,
      payload: state
    });
  };
  const cleanInputs = id => {
    dispatch({
      type: CLEAN_INPUTS,
      payload: state,
      id
    });
  };
  const cleanAllInputs = () => {
    dispatch({
      type: CLEAN_ALL_INPUTS,
      payload: state
    });
  };
  const selectDropdown = dropdownId => {
    dispatch({
      type: SELECT_DROPDOWN,
      payload: dropdownId
    });
  };
  const bottomSheetAction = value => {
    dispatch({
      type: BOTTOM_SHEET_ACTION,
      payload: value
    });
  };
  const handleStateWidgetAfterCancel = (optionValue, id, next_input, paramIds, paramValues) => {
    dispatch({
      type: FETCH_DROPDOWN_INIT,
      payload: state
    });
    if (next_input && paramIds && paramValues) {
      Service.getInputsCompats("".concat(state.modal.form.path, "?domain_id=").concat(state.modal.form.domain_id, "&filter_ids=").concat(paramIds, "&filter_values=").concat(paramValues, "&select_id=").concat(next_input), {}).then(payload => {
        dispatch({
          type: FETCH_DROPDOWN_FINISH,
          payload,
          next_input,
          optionValue,
          id
        });
        dispatch({
          type: CHECK_INPUTS_SELECTED,
          id,
          optionValue
        });
      }).catch(e => {
        dispatch({
          type: CHECK_INPUTS_SELECTED,
          next_input,
          optionValue: null
        });
        dispatch({
          type: FETCH_DROPDOWN_ERROR,
          e
        });
      }).finally(() => dispatch({
        type: RESET_ERROR
      }));
    } else {
      dispatch({
        type: CHECK_INPUTS_SELECTED,
        id,
        optionValue
      });
    }
  };
  const fetchDropdownItems = (optionValue, id, next_input) => {
    const newComponents = state.modal.form.components.map((item, index) => {
      if (index < state.modal.form.components.indexOf(state.modal.form.components.find(input => input.id === id))) {
        return item;
      }
      if (item.id === id) {
        return item;
      }
      return _objectSpread(_objectSpread({}, item), {}, {
        selected_option: null,
        options: []
      });
    });
    const newState = _objectSpread(_objectSpread({}, state), {}, {
      modal: _objectSpread(_objectSpread({}, state.modal), {}, {
        form: _objectSpread(_objectSpread({}, state.modal.form), {}, {
          components: newComponents
        })
      }),
      completedInputs: false
    });
    dispatch({
      type: FETCH_DROPDOWN_INIT,
      payload: newState
    });
    const paramIds = "".concat(newState.modal.form.components.reduce((previousValue, currentValue) => "".concat(previousValue).concat(currentValue.selected_option && currentValue.id !== id ? "".concat(currentValue.id, ",") : ''), '')).concat(id);
    const paramValues = "".concat(newState.modal.form.components.reduce((previousValue, currentValue) => "".concat(previousValue).concat(currentValue.selected_option && currentValue.id !== id ? "".concat(currentValue.selected_option, ",") : ''), '')).concat(optionValue);
    if (next_input) {
      Service.getInputsCompats("".concat(newState.modal.form.path, "?domain_id=").concat(newState.modal.form.domain_id, "&filter_ids=").concat(paramIds, "&filter_values=").concat(paramValues, "&select_id=").concat(next_input), {}).then(payload => {
        dispatch({
          type: FETCH_DROPDOWN_FINISH,
          payload,
          next_input,
          optionValue,
          id
        });
        dispatch({
          type: CHECK_INPUTS_SELECTED,
          id,
          optionValue
        });
      }).catch(e => {
        dispatch({
          type: CHECK_INPUTS_SELECTED,
          next_input,
          optionValue: null
        });
        dispatch({
          type: FETCH_DROPDOWN_ERROR,
          e
        });
      }).finally(() => dispatch({
        type: RESET_ERROR
      }));
    } else {
      dispatch({
        type: CHECK_INPUTS_SELECTED,
        id,
        optionValue
      });
    }
  };
  const fetchDropdownComplete = (optionValue, id, next_input) => {
    const firstInput = state.modal.form.components[0].id === id;
    if (firstInput) {
      Service.getInputsCompats("".concat(state.modal.form.path, "?domain_id=").concat(state.modal.form.domain_id, "&select_id=").concat(id), {}).then(payload => {
        dispatch({
          type: GET_FIRST_INPUT,
          payload,
          next_input,
          optionValue,
          id
        });
      }).catch(e => dispatch({
        type: FETCH_DROPDOWN_ERROR,
        e
      })).finally(() => dispatch({
        type: RESET_ERROR
      }));
    }
    const paramIds = state.modal.form.components.map(item => item.id).slice(0, state.modal.form.components.findIndex(item => item.id === id) + 1).map(item => "".concat(item)).toString();
    const paramValues = state.modal.form.components.map(item => item.selected_option).slice(0, state.modal.form.components.findIndex(item => item.id === id) + 1).map(item => "".concat(item)).toString();
    Service.getInputsCompats("".concat(state.modal.form.path, "?domain_id=").concat(state.modal.form.domain_id, "&filter_ids=").concat(paramIds, "&filter_values=").concat(paramValues, "&select_id=").concat(next_input), {}).then(payload => {
      dispatch({
        type: FETCH_DROPDOWN_FINISH,
        payload,
        next_input,
        optionValue,
        id
      });
      dispatch({
        type: CHECK_INPUTS_SELECTED,
        id,
        optionValue
      });
    }).catch(e => dispatch({
      type: FETCH_DROPDOWN_ERROR,
      e
    }));
  };
  const postCompats = () => {
    var _form$components;
    dispatch({
      type: SUBMIT_INIT,
      payload: state
    });
    const {
      modal: {
        form
      }
    } = state;
    const userSelection = form === null || form === void 0 || (_form$components = form.components) === null || _form$components === void 0 ? void 0 : _form$components.filter(input => !!input.selected_option).map(input => {
      const option = input.options.find(item => item.id === (input === null || input === void 0 ? void 0 : input.selected_option.toString()));
      return {
        id: input.id,
        selected_value: {
          display_label: option.display_label,
          id: input === null || input === void 0 ? void 0 : input.selected_option.toString()
        }
      };
    });
    const selectedInput = {
      main_domain: form.domain_id,
      user_selection: userSelection
    };
    const updateState = update => {
      dispatch({
        type: UPDATE_INITIAL,
        initialState: update
      });
    };
    onSubmitForm(selectedInput, updateState).then(() => {
      dispatch({
        type: SUBMIT_FINISH,
        payload: state
      });
    }).catch(() => dispatch({
      type: SUBMIT_ERROR,
      payload: form === null || form === void 0 ? void 0 : form.error_message
    }));
  };
  const deleteCompats = () => {
    dispatch({
      type: SUBMIT_INIT,
      payload: state
    });
    const {
      modal: {
        form
      }
    } = state;
    const selectedWidget = {
      main_domain: form.domain_id
    };
    const updateState = update => {
      dispatch({
        type: UPDATE_INITIAL,
        initialState: update
      });
    };
    onRemove(selectedWidget, updateState).then(() => {
      dispatch({
        type: SUBMIT_FINISH,
        payload: state
      });
    }).catch(() => dispatch({
      type: SUBMIT_ERROR,
      payload: form === null || form === void 0 ? void 0 : form.error_message
    }));
  };
  const isAutoOpenModal = value => {
    dispatch({
      type: AUTO_OPEN_MODAL_ACTION,
      payload: value
    });
  };
  return /*#__PURE__*/jsx(StateContext.Provider, {
    value: {
      state,
      dispatch,
      onCancelAction,
      onSubmitForm,
      onRemove,
      onEditAction,
      fetchDropdownItems,
      fetchDropdownComplete,
      postCompats,
      deleteCompats,
      cleanInputs,
      cleanAllInputs,
      bottomSheetAction,
      actionButtonForm,
      handleStateWidgetAfterCancel,
      selectDropdown,
      isAutoOpenModal
    },
    children: children
  });
};
const useStateValue = () => useContext(StateContext);

const ICON_ID$5 = 'chevron';
const namespace$f = 'ui-compats-icon ui-compats-icon--chevron';
const ChevronIcon = _ref => {
  let {
    className = null
  } = _ref;
  return /*#__PURE__*/jsx("svg", {
    className: classNames(namespace$f, className),
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      d: "M6.1935 7.71386L10.9891 12.5095L15.7898 7.70886L16.6383 8.55739L10.9891 14.2065L5.34497 8.56239L6.1935 7.71386Z",
      fill: "#3483FA"
    })
  });
};
const ChevronIconMemo = /*#__PURE__*/React.memo(ChevronIcon);
ChevronIconMemo.ICON_ID = ICON_ID$5;

const ICON_ID$4 = 'pencil';
const namespace$e = 'ui-compats-icon ui-compats-icon--pencil';
const PencilIcon = _ref => {
  let {
    className = null
  } = _ref;
  return /*#__PURE__*/jsx("svg", {
    className: classNames(namespace$e, className),
    width: "16",
    height: "16",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.3199 3.99374L8.88435 1.55743L1.23352 9.20661V11.6428H3.66837L8.88368 6.42921L8.88431 6.42984L11.3199 3.99374ZM8.88339 5.1562L10.0468 3.99334L8.88352 2.83009L7.72021 3.99315L8.88339 5.1562ZM7.08374 4.62947L2.13352 9.57859V10.7426H3.29452L8.24685 5.79246L7.08374 4.62947Z",
      fill: "#3483FA"
    })
  });
};
const PencilIconMemo = /*#__PURE__*/React.memo(PencilIcon);
PencilIconMemo.ICON_ID = ICON_ID$4;

const ICON_ID$3 = 'cross';
const namespace$d = 'ui-compats-icon ui-compats-icon--cross';
const CrossIcon = _ref => {
  let {
    className = null
  } = _ref;
  return /*#__PURE__*/jsx("svg", {
    className: classNames(namespace$d, className),
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      d: "M16.6403 15.7628L11.8378 10.9603L16.6403 6.1578L15.7917 5.30927L10.9892 10.1118L6.19548 5.31802L5.34695 6.16654L10.1407 10.9603L5.34695 15.7541L6.19548 16.6026L10.9892 11.8088L15.7917 16.6113L16.6403 15.7628Z",
      fill: "#3483FA"
    })
  });
};
const CrossIconMemo = /*#__PURE__*/React.memo(CrossIcon);
CrossIconMemo.ICON_ID = ICON_ID$3;

const ImageCompats = _ref => {
  let {
    width = null,
    height = null,
    url = null,
    alt_text = null,
    class_name = null,
    preload = true
  } = _ref;
  const namespace = 'ui-compats-image';
  return /*#__PURE__*/jsx("div", {
    className: classNames(namespace, {
      ["".concat(class_name)]: class_name
    }),
    children: /*#__PURE__*/jsx(Image, {
      src: url,
      width: width,
      height: height,
      alt: alt_text,
      preload: preload,
      lazyload: "off"
    })
  });
};

const createMarkup = text => ({
  __html: text
});
const namespace$c = 'ui-styled-label';
const setActionProps = (html_tag, href) => {
  const actionProps = {};
  if (html_tag === 'a' && (!href || href === '')) {
    actionProps.role = 'button';
    actionProps.tabIndex = 0;
  } else if (html_tag === 'a' && href) {
    actionProps.href = href;
  }
  return actionProps;
};
const StyledLabel = _ref => {
  let {
    styles = null,
    text = null,
    html_tag = 'span',
    class_name = null,
    href = null,
    onClick = null,
    onKeyDown = null,
    target = null,
    children = null,
    withDangerous = false,
    helpers = []
  } = _ref;
  const Element = html_tag || 'span';
  const actionProps = setActionProps(html_tag, href);
  if (withDangerous) {
    return /*#__PURE__*/jsx(Element, _objectSpread(_objectSpread({
      className: classNames(namespace$c, {
        ["".concat(class_name)]: class_name,
        ["".concat(namespace$c, "--").concat(styles === null || styles === void 0 ? void 0 : styles.color)]: styles === null || styles === void 0 ? void 0 : styles.color,
        ["".concat(namespace$c, "--").concat(styles === null || styles === void 0 ? void 0 : styles.font_weight)]: styles === null || styles === void 0 ? void 0 : styles.font_weight,
        ["".concat(namespace$c, "--").concat(styles === null || styles === void 0 ? void 0 : styles.font_size)]: styles === null || styles === void 0 ? void 0 : styles.font_size
      })
    }, actionProps), {}, {
      onClick: onClick,
      onKeyDown: onKeyDown,
      dangerouslySetInnerHTML: createMarkup(text)
    }));
  }
  return /*#__PURE__*/jsxs(Element, _objectSpread(_objectSpread({
    className: classNames(namespace$c, {
      ["".concat(class_name)]: class_name,
      ["".concat(namespace$c, "--").concat(styles === null || styles === void 0 ? void 0 : styles.color)]: styles === null || styles === void 0 ? void 0 : styles.color,
      ["".concat(namespace$c, "--").concat(styles === null || styles === void 0 ? void 0 : styles.font_weight)]: styles === null || styles === void 0 ? void 0 : styles.font_weight,
      ["".concat(namespace$c, "--").concat(styles === null || styles === void 0 ? void 0 : styles.font_size)]: styles === null || styles === void 0 ? void 0 : styles.font_size
    })
  }, actionProps), {}, {
    onClick: onClick,
    onKeyDown: onKeyDown,
    children: [html_tag !== 'a' && href && /*#__PURE__*/jsx("a", {
      className: "".concat(namespace$c, "__link"),
      href: href,
      target: target,
      children: text
    }), text && text, children && children, helpers && (helpers === null || helpers === void 0 ? void 0 : helpers.map((helper, index) => /*#__PURE__*/createElement(ImageCompats, _objectSpread(_objectSpread({}, helper), {}, {
      key: "image-".concat(index)
    }))))]
  }));
};

const ModalComp = _ref => {
  let {
    deviceType = '',
    title = '',
    children = {},
    isOpen = false,
    changeIsOpen = () => {},
    className = ''
  } = _ref;
  const onClose = () => {
    changeIsOpen(false);
  };
  return /*#__PURE__*/jsx(Modal, {
    closeButtonLabel: "close modal",
    open: isOpen,
    onClose: onClose,
    title: title,
    type: deviceType,
    className: className,
    children: children
  });
};

const dataUpdate = (actionTrack, inputSelection, completionQty) => {
  let dataUpdated = null;
  if (actionTrack && actionTrack.melidata_event) {
    dataUpdated = _objectSpread(_objectSpread({}, actionTrack.melidata_event.event_data), {}, {
      user_selection: inputSelection,
      completion_qty: completionQty
    });
  }
  return dataUpdated;
};
const updateUserSelectionTrackPost = (modal, actionTrack) => {
  var _modal$form;
  const userSelection = modal === null || modal === void 0 || (_modal$form = modal.form) === null || _modal$form === void 0 || (_modal$form = _modal$form.components) === null || _modal$form === void 0 ? void 0 : _modal$form.filter(input => !!input.selected_option).map(input => {
    const option = input.options && input.options.find(item => item.id === (input === null || input === void 0 ? void 0 : input.selected_option.toString()));
    return {
      [input.id]: option === null || option === void 0 ? void 0 : option.display_label
    };
  });
  const inputSelection = Object.assign({}, ...userSelection);
  const completionQty = String(Object.keys(inputSelection).length);
  return dataUpdate(actionTrack, inputSelection, completionQty);
};
const updateUserSelectionTrackChange = (id, selectedOptionLabel, modal, actionTrack) => {
  var _modal$form2;
  const qtySelected = modal === null || modal === void 0 || (_modal$form2 = modal.form) === null || _modal$form2 === void 0 || (_modal$form2 = _modal$form2.components) === null || _modal$form2 === void 0 ? void 0 : _modal$form2.map((input, index) => {
    let qty = 0;
    if (input.id === id) {
      qty = index + 1;
    }
    return qty;
  });
  const inputSelection = selectedOptionLabel ? {
    [id]: selectedOptionLabel
  } : null;
  const completionQty = String(qtySelected.filter(qty => qty > 0));
  return dataUpdate(actionTrack, inputSelection, completionQty);
};

const namespace$b = 'ui-compats';
const ButtonComp = _ref => {
  var _modal$form, _modal$form2;
  let {
    disabled = false,
    id = null,
    size = null,
    text = null,
    onClick = null,
    hierarchy = null,
    shouldEnableButton = true,
    handleChangeState = () => {},
    actionsTracks = null
  } = _ref;
  const {
    postCompats,
    deleteCompats,
    state,
    actionButtonForm
  } = useStateValue();
  const [disableButton, setDisableButton] = useState(id && shouldEnableButton ? false : disabled);
  const [rendered, setRendered] = useState(true);
  const {
    modal = {}
  } = state;
  const actionsForm = modal.form.actions;
  const actions = actionsTracks !== null && actionsTracks !== void 0 ? actionsTracks : actionsForm;
  const UPDATE_USER_OPTIONS = 'update_user_options';
  const REMOVE_OPTIONS = 'remove_options';
  const CLOSE_MODAL = 'close_modal_options';
  const getLastInputIndex = modal === null || modal === void 0 || (_modal$form = modal.form) === null || _modal$form === void 0 ? void 0 : _modal$form.components.findIndex(element => !element.hasOwnProperty('next_input'));
  const finalInput = modal === null || modal === void 0 || (_modal$form2 = modal.form) === null || _modal$form2 === void 0 || (_modal$form2 = _modal$form2.components[getLastInputIndex]) === null || _modal$form2 === void 0 ? void 0 : _modal$form2.selected_option;
  const mainButton = id === UPDATE_USER_OPTIONS;
  const addTracks = actionId => {
    var _actions$filter$;
    const actionTrack = (_actions$filter$ = actions.filter(action => action.action_id === actionId)[0]) === null || _actions$filter$ === void 0 ? void 0 : _actions$filter$.track;
    if (window && window.melidata && actionTrack && actionTrack.melidata_event) {
      const {
        path
      } = actionTrack.melidata_event;
      const updateSelect = updateUserSelectionTrackPost(modal, actionTrack);
      const updateData = _objectSpread({}, updateSelect);
      window.melidata('cleanAndSend', 'event', {
        path,
        data: updateData
      });
    }
    if (window && window.meli_ga && actionTrack && actionTrack.analytics_event) {
      const {
        action,
        category
      } = actionTrack.analytics_event;
      window.meli_ga('send', 'event', category, action);
    }
  };
  useEffect(() => {
    if (mainButton && !rendered) {
      setDisableButton(!(state !== null && state !== void 0 && state.submitButton));
    } else if (mainButton && rendered) {
      setDisableButton(true);
    }
    setRendered(false);
  }, [state === null || state === void 0 ? void 0 : state.submitButton, finalInput]);
  const handlePost = ev => {
    ev.preventDefault();
    if (onClick) {
      onClick();
    }
    addTracks(UPDATE_USER_OPTIONS);
    postCompats();
    actionButtonForm(false);
    handleChangeState(ev);
  };
  const handleDelete = ev => {
    ev.preventDefault();
    if (onClick) {
      onClick();
    }
    addTracks(REMOVE_OPTIONS);
    handleChangeState(ev);
    deleteCompats();
  };
  const handleCloseModal = ev => {
    ev.preventDefault();
    if (onClick) {
      onClick();
    }
    addTracks(CLOSE_MODAL);
    actionButtonForm(false);
    handleChangeState(false);
  };
  const selectOnclickHandle = () => {
    switch (id) {
      case UPDATE_USER_OPTIONS:
        return handlePost;
      case REMOVE_OPTIONS:
        return handleDelete;
      case CLOSE_MODAL:
        return handleCloseModal;
      default:
        return null;
    }
  };
  const handleClick = selectOnclickHandle();
  return /*#__PURE__*/jsx(Button, {
    size: size.toLowerCase(),
    className: "".concat(namespace$b, "--button-search"),
    type: "submit",
    onClick: handleClick,
    disabled: disableButton,
    hierarchy: hierarchy.toLowerCase(),
    children: text
  });
};

const ANDES_COLOR = {
  'ANDES-ORANGE-500': '#f73',
  'ANDES-BLUE-500': '#3483fa',
  'ANDES-GREEN-500': '#00a650',
  'ANDES-RED-500': '#f23d4f'
};

const IS_DEV = process.env.NODE_ENV !== 'production';
const getIconComponent = (id, iconSet) => get(iconSet, id);
const buildComponent = (Component, props) => /*#__PURE__*/jsx(Component, _objectSpread({}, props));
const IconFactory$3 = iconSet => {
  const icons = iconSet.reduce((acc, i) => {
    acc[i.ICON_ID] = i;
    return acc;
  }, {});
  return (icon, className) => {
    if (/*#__PURE__*/React.isValidElement(icon)) {
      return /*#__PURE__*/React.cloneElement(icon, {
        className
      });
    }
    if (!isArray(iconSet)) {
      throw new Error('Bad Parameter, array expected');
    }
    let id;
    if (typeof icon === 'string') {
      id = icon.toLowerCase();
    } else if (isObject(icon) && typeof icon.id === 'string') {
      id = icon.id.toLowerCase();
    } else {
      if (IS_DEV) {
        warning(false, "icon must be an string or an object with id property, ".concat(typeof icon, " provided"));
      }
      return null;
    }
    const Component = getIconComponent(id, icons);
    if (!Component) {
      if (IS_DEV) {
        warning(false, "icon \"".concat(id, "\" not found"));
      }
      return null;
    }
    return Component ? buildComponent(Component, {
      description: icon.description,
      color: ANDES_COLOR["".concat(className)]
    }) : Component;
  };
};
const createIconFactory = iconSet => IconFactory$3(iconSet);

const IconFactory$2 = createIconFactory([ChevronIconMemo, CrossIconMemo, PencilIconMemo]);
const TRANSLATION_TYPE_BREAKPOINT = 'break';
const TRANSLATION_TYPE_ICON = 'ICON';
const TRANSLATION_TYPE_EVENT_MODAL = 'LABEL_EVENT_MODAL';
const INTERPOLATION_REGEXP = /{([\s\S]+?)}/g;
const namespace$a = 'ui-compats-label';
const firstPosition = 0;
const ACTION = 'EDIT_ACTION';
const LabelBuilder = _ref => {
  var _newRes$texts, _newRes$icons;
  let {
    text,
    values = null,
    styles = null,
    class_name = null,
    html_tag = null,
    onClick = null,
    onKeyDown = null,
    url = null,
    target = null,
    withDangerous = false,
    id
  } = _ref;
  const [isVisibleModal, setIsVisibleModal] = React.useState(false);
  if (!values) {
    return /*#__PURE__*/jsx(StyledLabel, {
      text: text,
      styles: styles,
      class_name: classNames(namespace$a, {
        ["".concat(namespace$a, "-").concat(class_name)]: class_name
      }),
      html_tag: html_tag,
      onClick: onClick,
      onKeyDown: onKeyDown,
      href: url,
      target: target,
      withDangerous: withDangerous
    });
  }
  const result = text.split(INTERPOLATION_REGEXP);
  const newRes = {
    texts: result,
    icons: []
  };
  const VEHICLE = 'vehicle';
  const UI_COMPATS = 'ui-compats';
  const ICON_TITLE = 'icon_title';
  const handleOpenModal = actionModal => {
    if (!isVisibleModal) {
      const actionOpen = actionModal.track_open;
      if (window && window.melidata && actionOpen) {
        window.melidata('cleanAndSend', 'event', {
          path: actionOpen && actionOpen.melidata_event.path,
          data: actionOpen && actionOpen.melidata_event.event_data
        });
      }
      if (window && window.meli_ga && actionOpen) {
        const category = actionOpen && actionOpen.analytics_event ? actionOpen.analytics_event.category : '';
        const action = actionOpen && actionOpen.analytics_event ? actionOpen.analytics_event.action : '';
        window.meli_ga('send', 'event', category, action);
      }
    }
  };
  const eventModal = action => {
    if (action.type === 'MODAL' && !isVisibleModal) {
      handleOpenModal(action);
      setIsVisibleModal(true);
    }
  };
  for (let index = 0; index < result.length; index += 1) {
    if (index === firstPosition && typeof result["".concat(index)] === 'string' && id === ACTION) {
      result["".concat(index)] = result["".concat(index)].trim();
    }
    const key = result["".concat(index)];
    values.forEach(element => {
      var _element$action$actio;
      if (element.tag.indexOf(key) !== -1 && key !== '') {
        switch (element.type) {
          case TRANSLATION_TYPE_ICON:
            newRes.texts["".concat(index)] = null;
            newRes.icons.push(/*#__PURE__*/jsx("span", {
              className: "".concat(UI_COMPATS, "-").concat(ICON_TITLE),
              children: IconFactory$2(element.icon_id)
            }, "span-".concat(UI_COMPATS, "-").concat(ICON_TITLE)));
            break;
          case TRANSLATION_TYPE_BREAKPOINT:
            newRes.texts["".concat(index)] = /*#__PURE__*/jsx("br", {});
            break;
          case TRANSLATION_TYPE_EVENT_MODAL:
            newRes.texts["".concat(index)] = /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsx(StyledLabel, {
                text: element.text,
                styles: element.styles,
                class_name: element.tag === '{vehicle}' ? "".concat(namespace$a, "-").concat(VEHICLE) : classNames({
                  ["".concat(namespace$a, "-").concat(element.class_name)]: element.class_name
                }),
                html_tag: element.html_tag,
                onClick: () => eventModal(element.action),
                onKeyDown: element.onKeyDown,
                href: element.url,
                target: element.target,
                withDangerous: element.withDangerous
              }, "element-type-".concat(index)), element.action.type === 'MODAL' && /*#__PURE__*/jsxs(ModalComp, {
                deviceType: element.action.deviceType,
                title: element.action.title,
                isOpen: isVisibleModal,
                changeIsOpen: setIsVisibleModal,
                className: classNames({
                  ["".concat(namespace$a, "-").concat(element.action.type)]: element.action.type
                }),
                children: [element.action.labels && element.action.labels.map((label, idx) => /*#__PURE__*/jsx("span", {
                  className: classNames("".concat(namespace$a, "__").concat(label.id)),
                  children: /*#__PURE__*/jsx(LabelBuilder, _objectSpread({}, label))
                }, "".concat(label.id, "-").concat(idx))), element.action.actions && /*#__PURE__*/jsx("div", {
                  className: classNames("".concat(namespace$a, "__actions")),
                  children: (_element$action$actio = element.action.actions) === null || _element$action$actio === void 0 ? void 0 : _element$action$actio.map(action => /*#__PURE__*/jsx(React.Fragment, {
                    children: /*#__PURE__*/jsx(ButtonComp, {
                      id: action.action_id,
                      size: action.size,
                      hierarchy: action.hierarchy,
                      disabled: !action.is_enable,
                      text: action.text,
                      shouldEnableButton: true,
                      actionsTracks: element.action.actions,
                      handleChangeState: setIsVisibleModal
                    })
                  }, action.action_id))
                })]
              })]
            });
            break;
          default:
            newRes.texts["".concat(index)] = /*#__PURE__*/jsx(StyledLabel, {
              text: element.text,
              styles: element.styles,
              class_name: element.tag === '{vehicle}' ? "".concat(namespace$a, "-").concat(VEHICLE) : classNames({
                ["".concat(namespace$a, "-").concat(element.class_name)]: element.class_name
              }),
              html_tag: element.html_tag,
              onClick: element.onClick,
              onKeyDown: element.onKeyDown,
              href: element.url,
              target: element.target,
              withDangerous: element.withDangerous,
              helpers: element.helpers
            }, "element-type-".concat(index));
            break;
        }
      }
    });
  }
  const texts = Array.from((_newRes$texts = newRes === null || newRes === void 0 ? void 0 : newRes.texts) !== null && _newRes$texts !== void 0 ? _newRes$texts : []);
  const icons = Array.from((_newRes$icons = newRes === null || newRes === void 0 ? void 0 : newRes.icons) !== null && _newRes$icons !== void 0 ? _newRes$icons : []);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(StyledLabel, {
      styles: styles,
      class_name: classNames(namespace$a, {
        ["".concat(namespace$a, "-").concat(class_name)]: class_name
      }),
      html_tag: html_tag,
      onClick: onClick,
      onKeyDown: onKeyDown,
      href: url,
      target: target,
      withDangerous: withDangerous,
      children: [texts, id !== ACTION && icons]
    }, text), id === ACTION && icons]
  });
};

function componentFactoryFrom(sources) {
  function ComponentFactory(component) {
    const source = sources[component.type];
    if (!source) return null;
    const props = component;
    return /*#__PURE__*/React.createElement(source, props);
  }
  return ComponentFactory;
}

const getCookie = name => {
  const match = document.cookie.match(new RegExp("(^|;\\s*)(".concat(name, ")=([^;]*)")));
  if (match) {
    try {
      return {
        [name]: JSON.parse(match[3])
      };
    } catch (e) {
      return {
        [name]: match[3]
      };
    }
  }
  return null;
};
const setCookie = function (name, value) {
  let attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let cookieValue;
  if (typeof value === 'object') {
    const cookie = getCookie(name);
    cookieValue = JSON.stringify(cookie ? merge(cookie[name], value) : value);
  } else {
    cookieValue = value;
  }
  const keys = Object.keys(attrs);
  let cookieAttrs = '';
  if (keys.length > 0) cookieAttrs = keys.reduce((acum, key) => "".concat(acum, ";").concat(key, "=").concat(attrs[key]), '');
  document.cookie = "".concat(name, "=").concat(cookieValue).concat(cookieAttrs);
};
const getExpiration = exdays => {
  const expFromNow = Date.now() + exdays * 24 * 60 * 60 * 1000;
  return new Date(expFromNow).toUTCString();
};

const DEFAULT_ATTRS$2 = {
  path: '/'
};
function useViewCounter(_ref) {
  let {
    id,
    visible,
    storable,
    cookieName,
    attrs = DEFAULT_ATTRS$2
  } = _ref;
  useEffect(() => {
    if (storable) {
      if (!attrs.expires) {
        attrs.expires = getExpiration(365);
      }
      const now = Math.floor(Date.now() / 1000);
      const status = {
        view_cnt: visible ? 1 : 0,
        close_cnt: 0,
        view_time: visible ? now : 0,
        close_time: 0
      };
      const cookie = getCookie(cookieName);
      if (cookie) {
        let cookieStatus = get(cookie, "".concat(cookieName, ".").concat(id), {
          view_cnt: 0,
          close_cnt: 0
        });
        cookieStatus = cookieStatus || {};
        if (visible) {
          status.view_cnt = cookieStatus.view_cnt + 1;
          status.view_time = now;
        }
        status.close_cnt = cookieStatus.close_cnt;
        status.close_time = cookieStatus.close_time;
      }
      setCookie(cookieName, {
        [id]: status
      }, _objectSpread({}, attrs));
    }
  }, [id]);
  const updateCloseStatus = () => {
    const cookie = getCookie(cookieName);
    const {
      close_cnt: closeCount
    } = get(cookie, "".concat(cookieName, ".").concat(id));
    setCookie(cookieName, {
      [id]: {
        close_cnt: closeCount + 1,
        close_time: Math.floor(Date.now() / 1000)
      }
    }, _objectSpread(_objectSpread({}, attrs), {}, {
      expires: getExpiration(365)
    }));
  };
  return storable ? updateCloseStatus : null;
}

const namespace$9 = 'ui-compats';
const COOKIE_NAME$3 = 'compats-tooltip';
const DropWithSearch = _ref => {
  let {
    id = null,
    options = [],
    placeholder = null,
    search_placeholder = null,
    next_input = null,
    selected_option = null,
    searchable = true,
    tooltip = null,
    open = false,
    track = null,
    label = null,
    options_group = null,
    menuAlignment = 'bottom'
  } = _ref;
  let openTooltipOptions = {};
  let tooltipOptions = {};
  const {
    body,
    closeable,
    id: tooltip_id,
    tooltip_location,
    tooltip_style,
    show_closable_button,
    trigger,
    visible,
    storable
  } = tooltip || {};
  const [tooltipVisibility, setTooltipVisibility] = useState(visible);
  if (tooltip) {
    if (open) {
      openTooltipOptions = {
        side: 'right',
        offsetX: 104,
        offsetY: 55,
        className: "".concat(namespace$9, "-toolip-with-dropdown")
      };
    }
    tooltipOptions = _objectSpread({
      id: tooltip_id,
      open: tooltipVisibility,
      closable: show_closable_button,
      content: body,
      closeable,
      side: tooltip_location,
      trigger,
      type: tooltip_style ? tooltip_style.toLowerCase() : '',
      storable
    }, openTooltipOptions);
  }
  const updateCloseStatus = useViewCounter({
    id: tooltip_id,
    visible: tooltipVisibility,
    storable,
    cookieName: COOKIE_NAME$3
  });
  const handleCloseTooltip = () => {
    if (storable) {
      setTooltipVisibility(false);
      updateCloseStatus();
    }
  };
  const adjustDropdownMenu = () => {
    const isOverflowedRight = element => {
      const rect = element.getBoundingClientRect();
      return rect.right >= (window.innerWidth || document.documentElement.clientWidth);
    };
    const alignElementLeft = element => {
      const rect = element.getBoundingClientRect();
      const gap = rect.right - element.parentElement.getBoundingClientRect().right;
      element.style.transform = "translateX(-".concat(gap, "px)");
    };
    setTimeout(() => {
      const dropdownContainer = document.querySelector('.ui-compats .andes-card__content');
      if (dropdownContainer && isOverflowedRight(dropdownContainer)) {
        alignElementLeft(dropdownContainer);
      }
    }, 0);
  };
  const {
    state,
    fetchDropdownItems,
    fetchDropdownComplete,
    selectDropdown
  } = useStateValue();
  const {
    modal = {}
  } = state;
  const {
    autocomplete_dropdown,
    auto_open_dropdown,
    components
  } = modal.form;
  const [selectedOption] = useState(selected_option);
  const menuMaxHeight = state !== null && state !== void 0 && state.isMobile ? 300 : undefined;
  const handleDropdownClick = () => {
    if (!open) {
      handleCloseTooltip();
      adjustDropdownMenu();
      selectDropdown(id);
    }
  };
  const handleChange = (_, optionValue) => {
    const optionLabel = options.find(option => option.id === optionValue);
    if (window && window.melidata && track && track.melidata_event) {
      const {
        path
      } = track.melidata_event;
      const updateSelect = updateUserSelectionTrackChange(id, optionLabel.display_label, modal, track);
      const updateData = _objectSpread({}, updateSelect);
      window.melidata('cleanAndSend', 'event', {
        path,
        data: updateData
      });
    }
    if (window && window.meli_ga && track && track.analytics_event) {
      const {
        action,
        category
      } = track.analytics_event;
      window.meli_ga('send', 'event', category, action);
    }
    fetchDropdownItems(optionValue, id, next_input);
    if (open) {
      handleCloseTooltip();
    }
  };
  useEffect(() => {
    if (autocomplete_dropdown && options.length === 1 && !selected_option) {
      handleChange(null, options[0].id);
    } else if (auto_open_dropdown && !selected_option && options.length > 0 && components[0].id !== id) {
      const dropdownBtn = document.querySelector("#".concat(id, " button"));
      setTimeout(() => dropdownBtn && dropdownBtn.click(), 250);
    }
  }, [options]);
  useEffect(() => {
    if (selectedOption && !!next_input) {
      fetchDropdownComplete(selected_option, id, next_input);
    }
  }, [selectedOption]);
  useEffect(() => {
    if (!selected_option && options.length > 0) {
      const dropdownBtn = document.querySelector("#".concat(id, " button"));
      setTimeout(() => dropdownBtn && dropdownBtn.focus(), 250);
    }
    if (!next_input) {
      var _document$querySelect;
      const submitBtn = (_document$querySelect = document.querySelector("[name=\"".concat(id, "\"]"))) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.closest('.ui-compats__inputs-container')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.querySelector('.andes-button--loud');
      setTimeout(() => submitBtn && submitBtn.focus(), 250);
    }
  }, [state.modal, state.data, state.submitButton, state.completedInputs, state.loading]);
  const renderDropdown = () => /*#__PURE__*/jsx(Dropdown, {
    className: classNames(namespace$9, "".concat(namespace$9, "--dropdown")),
    value: selected_option,
    srLabel: label,
    placeholder: placeholder,
    type: "form",
    name: id,
    onClick: e => handleDropdownClick(),
    onChange: (event, optionValue, e) => handleChange(event, optionValue),
    disabled: isEmpty(options),
    menuAlignment: menuAlignment,
    search: searchable ? {
      searchPlaceholder: search_placeholder
    } : undefined,
    menuMaxHeight: menuMaxHeight,
    defaultOpen: open,
    onClose: e => handleCloseTooltip(),
    label: label,
    id: id,
    children: options && options.map(_ref2 => {
      let {
        id: optionId,
        display_label
      } = _ref2;
      return /*#__PURE__*/jsx(DropdownItem, {
        value: optionId,
        title: display_label
      }, optionId);
    })
  });
  const renderDropdownGroup = () => /*#__PURE__*/jsxs(Dropdown, {
    className: classNames(namespace$9, "".concat(namespace$9, "--dropdown")),
    value: selected_option,
    srLabel: label,
    placeholder: placeholder,
    type: "form",
    name: id,
    onClick: e => handleDropdownClick(),
    onChange: (event, optionValue, e) => handleChange(event, optionValue),
    disabled: isEmpty(options),
    menuAlignment: menuAlignment,
    search: searchable ? {
      searchPlaceholder: search_placeholder
    } : undefined,
    menuMaxHeight: menuMaxHeight,
    defaultOpen: open,
    onClose: e => handleCloseTooltip(),
    label: label,
    id: id,
    children: [options && options_group && options_group.label_group && /*#__PURE__*/jsx(DropdownGroup, {
      label: options_group === null || options_group === void 0 ? void 0 : options_group.label_group,
      children: options.slice(0, options_group.index_group).map(_ref3 => {
        let {
          id: optionId,
          display_label
        } = _ref3;
        return /*#__PURE__*/jsx(DropdownItem, {
          value: optionId,
          title: display_label
        }, optionId);
      })
    }, options_group === null || options_group === void 0 ? void 0 : options_group.label_group), options && options_group && options_group.label_result && /*#__PURE__*/jsx(DropdownGroup, {
      label: options_group === null || options_group === void 0 ? void 0 : options_group.label_result,
      children: options.slice(options_group.index_group).map(_ref4 => {
        let {
          id: optionId,
          display_label
        } = _ref4;
        return /*#__PURE__*/jsx(DropdownItem, {
          value: optionId,
          title: display_label
        }, optionId);
      })
    }, options_group === null || options_group === void 0 ? void 0 : options_group.label_result)]
  });
  const render = () => options_group ? renderDropdownGroup() : renderDropdown();
  return tooltip ? /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({}, tooltipOptions), {}, {
    onClose: handleCloseTooltip,
    children: render()
  })) : render();
};

const sources = {};
const DROPDOWN_WITH_SEARCH = 'DROPDOWN_WITH_SEARCH';
const SUBMIT = 'SUBMIT';
sources[DROPDOWN_WITH_SEARCH] = DropWithSearch;
sources[SUBMIT] = ButtonComp;
const ComponentFactory$1 = componentFactoryFrom(sources);

const namespace$8 = 'ui-compats';
const FormDesktop = _ref => {
  let {
    form = null,
    stateEmpty = true,
    handleChangeState = () => {}
  } = _ref;
  const buttonSubmitRef = useRef(null);
  const dropdownsContainerRef = useRef(null);
  const {
    state
  } = useStateValue();
  const {
    method,
    path,
    target,
    components,
    actions,
    class_name
  } = form;
  return /*#__PURE__*/jsx(AndesForm, {
    className: classNames("".concat(namespace$8, "__form-container"), {
      [class_name]: class_name
    }),
    method: method,
    action: path,
    target: target,
    "data-testid": "form",
    children: /*#__PURE__*/jsxs("div", {
      className: classNames("".concat(namespace$8, "__inputs-container"), {
        ["".concat(namespace$8, "__inputs-container--with-rows")]: !stateEmpty
      }),
      ref: dropdownsContainerRef,
      children: [components && /*#__PURE__*/jsx("div", {
        className: classNames("".concat(namespace$8, "__inputs"), {
          ["".concat(namespace$8, "__row")]: !stateEmpty
        }),
        children: components.map(component => /*#__PURE__*/jsx(React.Fragment, {
          children: /*#__PURE__*/jsx(ComponentFactory$1, _objectSpread(_objectSpread({}, component), {}, {
            menuAlignment: "center"
          }))
        }, component.id))
      }), actions && /*#__PURE__*/jsx("div", {
        className: classNames("".concat(namespace$8, "__actions"), {
          ["".concat(namespace$8, "__row")]: !stateEmpty
        }),
        ref: buttonSubmitRef,
        children: actions.map(action => /*#__PURE__*/jsx(React.Fragment, {
          children: /*#__PURE__*/jsx(ButtonComp, {
            id: action.action_id,
            size: action.size,
            hierarchy: action.hierarchy,
            disabled: !action.is_enable,
            text: action.text,
            shouldEnableButton: state === null || state === void 0 ? void 0 : state.completedInputs,
            handleChangeState: handleChangeState
          })
        }, action.action_id))
      })]
    })
  });
};

const ICON_ID$2 = 'ellipse-checked';
const namespace$7 = 'ui-compats-icon ui-compats-icon--ellipse-checked';
const EllipseChecked = _ref => {
  let {
    className = null,
    color = '#3483FA'
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    className: classNames(namespace$7, className),
    width: "37",
    height: "37",
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("circle", {
      cx: "18.7568",
      cy: "18.958",
      r: "16.5",
      fill: "white",
      stroke: color,
      strokeWidth: "3"
    }), /*#__PURE__*/jsx("path", {
      d: "M16.3326 21.7495L25.4859 12.5962L27.5429 14.6532L16.3326 25.8636L9.9707 19.5017L12.0277 17.4447L16.3326 21.7495Z",
      fill: color
    })]
  });
};
const EllipseCheckedMemo = /*#__PURE__*/React.memo(EllipseChecked);
EllipseCheckedMemo.ICON_ID = ICON_ID$2;

const ICON_ID$1 = 'alert';
const namespace$6 = 'ui-compats-icon ui-compats-icon--alert';
const AlertIcon = _ref => {
  let {
    className = null,
    color = '#3483FA'
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    className: classNames(namespace$6, className),
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("circle", {
      cx: "18.5",
      cy: "18",
      r: "16.5",
      fill: "white",
      stroke: color,
      strokeWidth: "3"
    }), /*#__PURE__*/jsx("path", {
      d: "M20.4393 9.75781H16.5605L17.0454 20.4245H19.9545L20.4393 9.75781Z",
      fill: color
    }), /*#__PURE__*/jsx("path", {
      d: "M18.4999 22.3639C19.571 22.3639 20.4393 23.2322 20.4393 24.3033C20.4393 25.3744 19.571 26.2427 18.4999 26.2427C17.4288 26.2427 16.5605 25.3744 16.5605 24.3033C16.5605 23.2322 17.4288 22.3639 18.4999 22.3639Z",
      fill: color
    })]
  });
};
const AlertIconMemo = /*#__PURE__*/React.memo(AlertIcon);
AlertIconMemo.ICON_ID = ICON_ID$1;

const ICON_ID = 'ellipse-search';
const namespace$5 = 'ui-compats-icon ui-compats-icon--ellipse-search';
const EllipseSearch = _ref => {
  let {
    className = null,
    color = '#3483FA'
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    className: classNames(namespace$5, className),
    width: "37",
    height: "36",
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx("path", {
      d: "M36.5531 18C36.5531 27.9411 28.4942 36 18.5531 36C8.61199 36 0.553116 27.9411 0.553116 18C0.553116 8.05887 8.61199 0 18.5531 0C28.4942 0 36.5531 8.05887 36.5531 18Z",
      fill: "white"
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.5531 33C26.8374 33 33.5531 26.2843 33.5531 18C33.5531 9.71573 26.8374 3 18.5531 3C10.2688 3 3.55312 9.71573 3.55312 18C3.55312 26.2843 10.2688 33 18.5531 33ZM18.5531 36C28.4942 36 36.5531 27.9411 36.5531 18C36.5531 8.05887 28.4942 0 18.5531 0C8.61199 0 0.553116 8.05887 0.553116 18C0.553116 27.9411 8.61199 36 18.5531 36Z",
      fill: color
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.9321 20.7002C22.8259 19.6516 23.3654 18.2919 23.3654 16.8061C23.3654 13.489 20.6763 10.8 17.3592 10.8C14.0422 10.8 11.3531 13.489 11.3531 16.8061C11.3531 20.1232 14.0422 22.8122 17.3592 22.8122C18.845 22.8122 20.2048 22.2728 21.2533 21.379L24.9154 25.0411L25.5942 24.3622L21.9321 20.7002ZM17.3592 21.8522C14.5723 21.8522 12.3131 19.593 12.3131 16.8061C12.3131 14.0192 14.5723 11.76 17.3592 11.76C20.1461 11.76 22.4054 14.0192 22.4054 16.8061C22.4054 19.593 20.1461 21.8522 17.3592 21.8522Z",
      stroke: color,
      strokeWidth: "1.8"
    })]
  });
};
const EllipseSearchMemo = /*#__PURE__*/React.memo(EllipseSearch);
EllipseSearchMemo.ICON_ID = ICON_ID;

const handleStateWidget = (handleStateWidgetAfterCancel, cleanInputs, formSelection) => {
  let paramIds = '';
  let paramValues = '';
  if (formSelection) {
    formSelection.forEach(key => {
      cleanInputs(key.id);
      const next_input = key.next_input ? key.next_input : null;
      paramValues = paramValues ? "".concat(paramValues, ",").concat(key.selected_option) : key.selected_option;
      paramIds = paramIds ? "".concat(paramIds, ",").concat(key.id) : key.id;
      handleStateWidgetAfterCancel(key.selected_option, key.id, next_input, paramIds, paramValues);
    });
  }
};

const HelpersBuilder = _ref => {
  var _selectedDropdown$hel;
  let {
    selectedDropdown = null,
    helpers = null
  } = _ref;
  return selectedDropdown !== null && selectedDropdown !== void 0 && selectedDropdown.helpers ? (_selectedDropdown$hel = selectedDropdown.helpers) === null || _selectedDropdown$hel === void 0 ? void 0 : _selectedDropdown$hel.map((helper, index) => /*#__PURE__*/createElement(ImageCompats, _objectSpread(_objectSpread({}, helper), {}, {
    key: "helper-".concat(index)
  }))) : helpers === null || helpers === void 0 ? void 0 : helpers.map((helper, index) => /*#__PURE__*/createElement(ImageCompats, _objectSpread(_objectSpread({}, helper), {}, {
    key: "helper-".concat(index)
  })));
};

const trackEvent = track => {
  if (window && window.melidata) {
    window.melidata('cleanAndSend', 'event', {
      path: track && track.melidata_event.path,
      data: track && track.melidata_event.event_data
    });
  }
  if (window && window.meli_ga) {
    const category = track && track.analytics_event ? track.analytics_event.category : '';
    const action = track && track.analytics_event ? track.analytics_event.action : '';
    window.meli_ga('send', 'event', category, action);
  }
};

const COOKIE_NAME$2 = 'compats-tooltip';
const ActionBuilder = function () {
  let act = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    styles: null
  };
  let handleClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  const {
    andes_tooltip
  } = act.target || {};
  const {
    body,
    closeable,
    id: tooltip_id,
    tooltip_location,
    tooltip_style,
    show_closable_button,
    trigger,
    visible,
    storable
  } = andes_tooltip || {};
  const [tooltipVisibility, setTooltipVisibility] = useState(visible);
  const tooltipOptions = {
    id: tooltip_id,
    open: tooltipVisibility,
    closable: show_closable_button,
    content: body,
    closeable,
    side: tooltip_location,
    trigger,
    type: tooltip_style ? tooltip_style.toLowerCase() : '',
    storable
  };
  const updateCloseStatus = useViewCounter({
    id: tooltip_id,
    visible: tooltipVisibility,
    storable,
    cookieName: COOKIE_NAME$2
  });
  const handleCloseTooltip = () => {
    if (storable) {
      setTooltipVisibility(false);
      updateCloseStatus();
    }
  };
  let renderAction;
  switch (act.type) {
    case 'BUTTON':
      renderAction = () => /*#__PURE__*/jsx(Button, {
        onClick: handleClick,
        children: /*#__PURE__*/jsx(LabelBuilder, _objectSpread({}, act))
      });
      break;
    case 'LINK':
      renderAction = () => /*#__PURE__*/jsx("span", {
        className: "ui-compats-header__EDIT_ACTION",
        children: /*#__PURE__*/jsx(LabelBuilder, _objectSpread(_objectSpread({}, act), {}, {
          onClick: handleClick
        }))
      });
      break;
    default:
      renderAction = () => /*#__PURE__*/jsx(LabelBuilder, _objectSpread(_objectSpread({}, act), {}, {
        onClick: handleClick
      }));
      break;
  }
  return andes_tooltip ? /*#__PURE__*/jsx(Tooltip, _objectSpread(_objectSpread({}, tooltipOptions), {}, {
    onClose: handleCloseTooltip,
    children: renderAction()
  })) : renderAction();
};

const RowLabelMobile = props => {
  const {
    labels,
    actions,
    namespace,
    handleClick = null,
    listActions = null
  } = props;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [labels && labels.map(labelItem => /*#__PURE__*/jsx("span", {
      className: classNames("".concat(namespace, "__").concat(labelItem.id)),
      children: /*#__PURE__*/createElement(LabelBuilder, _objectSpread(_objectSpread({}, labelItem), {}, {
        key: "lb-".concat(labelItem.id)
      }))
    }, "lbm-".concat(labelItem.id))), actions && listActions && actions.map(actionItem => ActionBuilder(actionItem, () => listActions(actionItem))), actions && handleClick && actions.map(actionItem => ActionBuilder(actionItem, handleClick))]
  });
};

const NAME_SPACE$5 = 'ui-compats-custom';
const CLOSE = 'CLOSE';
const VARIANTS = {
  NEUTRAL: {
    color: 'andes-white',
    type: 'neutral',
    shadow: 'elevated'
  },
  SUCCESS: {
    color: 'green',
    type: 'success',
    shadow: 'outline'
  },
  WARNING: {
    color: 'orange',
    type: 'warning',
    shadow: 'outline'
  },
  ERROR: {
    color: 'red',
    type: 'error',
    shadow: 'outline'
  }
};
const TITLE = 'TITLE';
const TITLE_MODAL = 'TITLE_MODAL';
const MOBILE = 'mobile';

const generateVariant = (type, open_modal) => {
  var _VARIANTS$type;
  if (open_modal) return VARIANTS.NEUTRAL;
  return (_VARIANTS$type = VARIANTS[type]) !== null && _VARIANTS$type !== void 0 ? _VARIANTS$type : VARIANTS.NEUTRAL;
};

const generateGroupedActions = actions => {
  if (!actions) {
    return {
      closeActions: {},
      clickAtions: []
    };
  }
  const groupedActions = actions === null || actions === void 0 ? void 0 : actions.reduce((accumulator, action) => {
    if (action.message_type === CLOSE) {
      accumulator.closeActions = action;
    } else {
      accumulator.clickAtions.push(action);
    }
    return accumulator;
  }, {
    closeActions: {},
    clickAtions: []
  });
  return groupedActions;
};

const generateInset = insets => {
  var _insets$top, _insets$right, _insets$bottom, _insets$left;
  return "".concat((_insets$top = insets === null || insets === void 0 ? void 0 : insets.top) !== null && _insets$top !== void 0 ? _insets$top : 0, "px ").concat((_insets$right = insets === null || insets === void 0 ? void 0 : insets.right) !== null && _insets$right !== void 0 ? _insets$right : 0, "px ").concat((_insets$bottom = insets === null || insets === void 0 ? void 0 : insets.bottom) !== null && _insets$bottom !== void 0 ? _insets$bottom : 0, "px ").concat((_insets$left = insets === null || insets === void 0 ? void 0 : insets.left) !== null && _insets$left !== void 0 ? _insets$left : 0, "px");
};

const generateSize = (fontSize, id) => {
  var _sizes$fontSize;
  const sizes = {
    XXSMALL: 'xs',
    XSMALL: 's',
    SMALL: 'm',
    MEDIUM: 'l'
  };
  const defaultSize = id === TITLE ? sizes.MEDIUM : sizes.SMALL;
  return (_sizes$fontSize = sizes[fontSize]) !== null && _sizes$fontSize !== void 0 ? _sizes$fontSize : defaultSize;
};

const generateWeight = fontWeight => {
  var _weights$fontWeight;
  const weights = {
    SEMIBOLD: 'semibold',
    REGULAR: 'regular'
  };
  return (_weights$fontWeight = weights[fontWeight]) !== null && _weights$fontWeight !== void 0 ? _weights$fontWeight : weights.REGULAR;
};

const generateColor = color => {
  var _colors$color;
  const colors = {
    'ANDES-WHITE': 'inverted',
    'ANDES-BLACK': 'primary'
  };
  return (_colors$color = colors[color]) !== null && _colors$color !== void 0 ? _colors$color : colors['ANDES-BLACK'];
};

const NAME_SPACE$4 = 'component-factory-label';
const ComponentFactoryLabel = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _element$styles, _element$styles2, _element$styles3;
  let {
    element,
    id,
    className
  } = _ref;
  const size = generateSize(element === null || element === void 0 || (_element$styles = element.styles) === null || _element$styles === void 0 ? void 0 : _element$styles.font_size, element === null || element === void 0 ? void 0 : element.id);
  const weight = generateWeight(element === null || element === void 0 || (_element$styles2 = element.styles) === null || _element$styles2 === void 0 ? void 0 : _element$styles2.font_weight);
  const color = generateColor(element === null || element === void 0 || (_element$styles3 = element.styles) === null || _element$styles3 === void 0 ? void 0 : _element$styles3.color);
  const props = {
    size,
    weight,
    color,
    component: element === null || element === void 0 ? void 0 : element.html_tag
  };
  const classNamesComponentFactoryLabel = classNames("".concat(NAME_SPACE$4), className, "".concat(NAME_SPACE$4, "__").concat(element.class_name));
  return /*#__PURE__*/jsxs("div", {
    id: id,
    ref: ref,
    className: classNamesComponentFactoryLabel,
    style: {
      margin: generateInset(element === null || element === void 0 ? void 0 : element.insets)
    },
    children: [/*#__PURE__*/jsx(Typography, _objectSpread(_objectSpread({}, props), {}, {
      children: element === null || element === void 0 ? void 0 : element.text
    })), /*#__PURE__*/jsx(Bullets, {
      bullets: element === null || element === void 0 ? void 0 : element.bullets
    })]
  });
});
const Bullets = _ref2 => {
  let {
    bullets
  } = _ref2;
  return bullets && /*#__PURE__*/jsx("ul", {
    className: "".concat(NAME_SPACE$4, "__bullets"),
    children: bullets.map((bullet, i) => /*#__PURE__*/jsx("li", {
      className: classNames({
        ["".concat(NAME_SPACE$4, "__bullets--item")]: (bullets === null || bullets === void 0 ? void 0 : bullets.length) > 1
      }),
      children: /*#__PURE__*/jsx("div", {
        className: "".concat(NAME_SPACE$4, "__bullets--item-label"),
        children: /*#__PURE__*/jsx(ComponentFactoryLabel, {
          element: bullet
        })
      })
    }, "bullet-".concat(bullet === null || bullet === void 0 ? void 0 : bullet.id, "-").concat(i)))
  });
};

const NAME_SPACE$3 = 'component-factory-header';
const ComponentFactoryHeader = _ref => {
  let {
    element,
    color,
    classNamePill,
    id
  } = _ref;
  return /*#__PURE__*/jsxs("div", {
    style: {
      margin: generateInset(element === null || element === void 0 ? void 0 : element.insets)
    },
    className: NAME_SPACE$3,
    id: id,
    children: [/*#__PURE__*/jsx("div", {
      className: "".concat(NAME_SPACE$3, "__badge"),
      children: /*#__PURE__*/jsx(Pill, {
        className: classNamePill,
        contentType: "icon",
        color: color,
        size: "small",
        id: element.icon_id
      })
    }), /*#__PURE__*/jsx("div", {
      className: "".concat(NAME_SPACE$3, "__text"),
      children: /*#__PURE__*/jsx(ComponentFactoryLabel, {
        element: element.label
      })
    })]
  });
};

const ComponentFactoryLink = _ref => {
  let {
    element,
    onClick,
    id
  } = _ref;
  return /*#__PURE__*/jsx("div", {
    id: id,
    style: {
      margin: generateInset(element === null || element === void 0 ? void 0 : element.insets)
    },
    children: /*#__PURE__*/jsx(Typography, {
      onClick: onClick,
      weight: "semibold",
      color: "link",
      component: "a",
      size: "s",
      children: element === null || element === void 0 ? void 0 : element.text
    })
  });
};

const AddIcon = () => /*#__PURE__*/jsx("svg", {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/jsx("path", {
    d: "M7.9 7.40098V2.00098H9.1V7.40098H14.5V8.60098H9.1V14.001H7.9V8.60098H2.5V7.40098H7.9Z",
    fill: "white"
  })
});

const generateIcon = icon => {
  var _icons$icon;
  const icons = {
    ui_plus: AddIcon
  };
  return (_icons$icon = icons[icon]) !== null && _icons$icon !== void 0 ? _icons$icon : null;
};

const NAME_SPACE$2 = 'component-factory-button';
const ComponentFactoryButton = _ref => {
  var _element$button_size$, _element$button_size, _element$hierarchy$to, _element$hierarchy;
  let {
    element,
    onClick,
    id
  } = _ref;
  const size = (_element$button_size$ = element === null || element === void 0 || (_element$button_size = element.button_size) === null || _element$button_size === void 0 ? void 0 : _element$button_size.toLowerCase()) !== null && _element$button_size$ !== void 0 ? _element$button_size$ : 'medium';
  const hierarchy = (_element$hierarchy$to = element === null || element === void 0 || (_element$hierarchy = element.hierarchy) === null || _element$hierarchy === void 0 ? void 0 : _element$hierarchy.toLowerCase()) !== null && _element$hierarchy$to !== void 0 ? _element$hierarchy$to : 'loud';
  const Icon = generateIcon(element === null || element === void 0 ? void 0 : element.icon_id);
  return /*#__PURE__*/jsx("div", {
    className: NAME_SPACE$2,
    id: id,
    style: {
      margin: generateInset(element === null || element === void 0 ? void 0 : element.insets)
    },
    children: /*#__PURE__*/jsxs(Button$1, {
      onClick: onClick,
      size,
      hierarchy,
      fullWidth: true,
      children: [Icon && /*#__PURE__*/jsx(Icon, {}), /*#__PURE__*/jsx(ButtonText, {
        children: element === null || element === void 0 ? void 0 : element.text
      })]
    })
  });
};

const NAME_SPACE$1 = 'component-factory-divider';
const ComponentFactoryDivider = _ref => {
  let {
    element,
    id
  } = _ref;
  const className = classNames(NAME_SPACE$1, "".concat(NAME_SPACE$1, "--").concat(element === null || element === void 0 ? void 0 : element.color));
  return /*#__PURE__*/jsx("div", {
    id: id,
    className: className,
    style: {
      height: "".concat(element.height, "px"),
      margin: generateInset(element === null || element === void 0 ? void 0 : element.insets)
    }
  });
};

const NAME_SPACE = 'component-factory-notes';
const TruncatedComponent = _ref => {
  var _element$notes, _element$notes2, _element$notes3, _element$notes4, _element$notes5, _element$notes6, _element$notes7, _element$see_more_but3;
  let {
    element,
    platform,
    isOpenModal,
    setIsOpenModal,
    textRef
  } = _ref;
  const [isTruncated, setIsTruncated] = useState(false);
  const actionPrimary = (element === null || element === void 0 ? void 0 : element.modal_button) && /*#__PURE__*/jsx(ComponentFactoryButton, {
    element: element === null || element === void 0 ? void 0 : element.modal_button,
    onClick: () => setIsOpenModal(false)
  });
  useLayoutEffect(() => {
    const {
      clientHeight,
      scrollHeight
    } = textRef.current;
    const tolerance = 5;
    const adjustedClientHeight = clientHeight + tolerance;
    const isTruncatedText = scrollHeight > adjustedClientHeight;
    if (isTruncatedText) {
      setIsTruncated(true);
    }
  }, [textRef, element === null || element === void 0 || (_element$notes = element.notes) === null || _element$notes === void 0 ? void 0 : _element$notes.text]);
  const handleSeeMore = () => {
    var _element$see_more_but;
    setIsOpenModal(true);
    if (element !== null && element !== void 0 && (_element$see_more_but = element.see_more_button) !== null && _element$see_more_but !== void 0 && _element$see_more_but.track) {
      var _element$see_more_but2;
      trackEvent(element === null || element === void 0 || (_element$see_more_but2 = element.see_more_button) === null || _element$see_more_but2 === void 0 ? void 0 : _element$see_more_but2.track);
    }
  };
  return isTruncated ? /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(ComponentFactoryLink, {
      element: element === null || element === void 0 ? void 0 : element.see_more_button,
      onClick: () => handleSeeMore()
    }), platform === MOBILE ? /*#__PURE__*/jsx(BottomSheet, {
      className: "".concat(NAME_SPACE, "__bottom-sheet"),
      closable: true,
      open: isOpenModal,
      onClose: () => setIsOpenModal(false),
      title: element === null || element === void 0 ? void 0 : element.text,
      children: /*#__PURE__*/jsx(Typography, {
        size: generateSize(element === null || element === void 0 || (_element$notes2 = element.notes) === null || _element$notes2 === void 0 || (_element$notes2 = _element$notes2.styles) === null || _element$notes2 === void 0 ? void 0 : _element$notes2.font_size, element === null || element === void 0 || (_element$notes3 = element.notes) === null || _element$notes3 === void 0 ? void 0 : _element$notes3.id),
        children: element === null || element === void 0 || (_element$notes4 = element.notes) === null || _element$notes4 === void 0 ? void 0 : _element$notes4.text
      })
    }) : /*#__PURE__*/jsx(Modal$1, {
      className: "".concat(NAME_SPACE, "__modal"),
      title: element === null || element === void 0 ? void 0 : element.text,
      type: "small",
      open: isOpenModal,
      maxWidth: 480,
      onClose: () => setIsOpenModal(false),
      actions: {
        primary: actionPrimary
      },
      children: /*#__PURE__*/jsx(Typography, {
        size: generateSize(element === null || element === void 0 || (_element$notes5 = element.notes) === null || _element$notes5 === void 0 || (_element$notes5 = _element$notes5.styles) === null || _element$notes5 === void 0 ? void 0 : _element$notes5.font_size, element === null || element === void 0 || (_element$notes6 = element.notes) === null || _element$notes6 === void 0 ? void 0 : _element$notes6.id),
        children: element === null || element === void 0 || (_element$notes7 = element.notes) === null || _element$notes7 === void 0 ? void 0 : _element$notes7.text
      })
    })]
  }) : /*#__PURE__*/jsx("div", {
    style: {
      margin: generateInset(element === null || element === void 0 || (_element$see_more_but3 = element.see_more_button) === null || _element$see_more_but3 === void 0 ? void 0 : _element$see_more_but3.insets)
    }
  });
};
const ComponentFactoryNotes = _ref2 => {
  let {
    element,
    platform,
    id
  } = _ref2;
  const textRef = useRef(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  return /*#__PURE__*/jsxs("div", {
    id: id,
    className: "".concat(NAME_SPACE),
    children: [/*#__PURE__*/jsx(ComponentFactoryLabel, {
      element: element
    }), /*#__PURE__*/jsx(ComponentFactoryLabel, {
      ref: textRef,
      className: "".concat(NAME_SPACE, "__label"),
      element: element === null || element === void 0 ? void 0 : element.notes
    }), /*#__PURE__*/jsx(TruncatedComponent, {
      element,
      platform,
      isOpenModal,
      setIsOpenModal,
      textRef
    })]
  });
};

const getComponent = (type, props) => {
  const elements = {
    LABEL: /*#__PURE__*/createElement(ComponentFactoryLabel, props),
    LINK: /*#__PURE__*/createElement(ComponentFactoryLink, props),
    HEADER: /*#__PURE__*/createElement(ComponentFactoryHeader, props),
    BUTTON: /*#__PURE__*/createElement(ComponentFactoryButton, props),
    DIVIDER: /*#__PURE__*/createElement(ComponentFactoryDivider, props),
    NOTES: /*#__PURE__*/createElement(ComponentFactoryNotes, props)
  };
  return elements[type];
};

const ComponentFactory = props => {
  const {
    element
  } = props;
  const component = getComponent(element === null || element === void 0 ? void 0 : element.type, props);
  if (component) {
    return component;
  }
};

const generateLabelsBody = (labels, listActions) => labels === null || labels === void 0 ? void 0 : labels.map((element, i) => {
  var _element$id;
  return /*#__PURE__*/jsx(ComponentFactory, {
    id: "element-".concat(element === null || element === void 0 || (_element$id = element.id) === null || _element$id === void 0 ? void 0 : _element$id.toLowerCase(), "-").concat(i),
    element: element,
    onClick: () => listActions(element)
  }, "element-".concat(element === null || element === void 0 ? void 0 : element.id, "-").concat(i));
});
const CardContentDesktop = _ref => {
  var _groupedActions$close, _groupedActions$click;
  let {
    selectedVariant,
    isOpen,
    listActions
  } = _ref;
  const {
    state
  } = useStateValue();
  const {
    left_icon,
    modal = {},
    actions,
    config_type,
    body
  } = state;
  const {
    form,
    labels: formLabels,
    open_modal
  } = modal;
  const labels = open_modal ? formLabels : body;
  const groupedActions = generateGroupedActions(actions);
  const classNameCardContent = classNames("".concat(NAME_SPACE$5, "-card__content"), "".concat(NAME_SPACE$5, "-card__content--").concat(selectedVariant.type));
  const classNameDetailsIcon = classNames("".concat(NAME_SPACE$5, "-card__content-details-icon"), "".concat(NAME_SPACE$5, "-card__content-details-icon--").concat(selectedVariant.type));
  return /*#__PURE__*/jsx(CardContent, {
    children: /*#__PURE__*/jsxs("div", {
      className: classNameCardContent,
      children: [/*#__PURE__*/jsxs("div", {
        className: "".concat(NAME_SPACE$5, "-card__content--column"),
        children: [isOpen && (groupedActions === null || groupedActions === void 0 ? void 0 : groupedActions.closeActions) && (config_type === null || config_type === void 0 ? void 0 : config_type.closeable) && /*#__PURE__*/jsx("button", {
          id: "button-".concat(groupedActions === null || groupedActions === void 0 || (_groupedActions$close = groupedActions.closeActions) === null || _groupedActions$close === void 0 || (_groupedActions$close = _groupedActions$close.id) === null || _groupedActions$close === void 0 ? void 0 : _groupedActions$close.toLowerCase()),
          onClick: () => listActions(groupedActions === null || groupedActions === void 0 ? void 0 : groupedActions.closeActions),
          className: "".concat(NAME_SPACE$5, "-card__content--close"),
          type: "button",
          children: /*#__PURE__*/jsx(Close24, {})
        }), /*#__PURE__*/jsxs("div", {
          className: "".concat(NAME_SPACE$5, "-card__content-details"),
          children: [/*#__PURE__*/jsx(Image, {
            className: classNameDetailsIcon,
            src: left_icon.url,
            alt: left_icon.alt,
            preload: true,
            lazyload: "off"
          }), /*#__PURE__*/jsx("div", {
            children: generateLabelsBody(labels, listActions)
          })]
        }), !open_modal && (groupedActions === null || groupedActions === void 0 || (_groupedActions$click = groupedActions.clickAtions) === null || _groupedActions$click === void 0 ? void 0 : _groupedActions$click.map((actionItem, i) => {
          var _actionItem$id;
          return /*#__PURE__*/jsx(ComponentFactory, {
            element: actionItem,
            id: "button-".concat(actionItem === null || actionItem === void 0 || (_actionItem$id = actionItem.id) === null || _actionItem$id === void 0 ? void 0 : _actionItem$id.toLowerCase(), "-").concat(i),
            onClick: () => listActions(actionItem)
          }, "button-".concat(actionItem === null || actionItem === void 0 ? void 0 : actionItem.id, "-").concat(i));
        }))]
      }), isOpen && form && /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx(FormDesktop, {
          form: form,
          stateEmpty: !open_modal,
          formLabels: formLabels
        })
      })]
    })
  });
};

const CardHeaderDesktop = _ref => {
  let {
    selectedVariant
  } = _ref;
  const {
    state
  } = useStateValue();
  const {
    modal = {},
    header
  } = state;
  const {
    open_modal
  } = modal;
  const classNameCardHeader = classNames("".concat(NAME_SPACE$5, "-card__header"), "".concat(NAME_SPACE$5, "-card__header--").concat(selectedVariant.type));
  const classNamePill = classNames("".concat(NAME_SPACE$5, "-card__header-badge"), "".concat(NAME_SPACE$5, "-card__header-badge--").concat(selectedVariant.type));
  return !open_modal && header && /*#__PURE__*/jsx(CardHeader, {
    className: classNameCardHeader,
    showBorder: false,
    children: /*#__PURE__*/jsx("div", {
      children: header === null || header === void 0 ? void 0 : header.map((headerItem, i) => /*#__PURE__*/jsx(ComponentFactory, {
        element: headerItem,
        color: selectedVariant.color,
        classNamePill: classNamePill,
        id: "element-".concat(headerItem === null || headerItem === void 0 ? void 0 : headerItem.id, "-").concat(i)
      }, "element-".concat(headerItem === null || headerItem === void 0 ? void 0 : headerItem.id, "-").concat(i)))
    })
  });
};

const CardFooterDesktop = _ref => {
  let {
    listActions
  } = _ref;
  const {
    state
  } = useStateValue();
  const {
    footer
  } = state;
  return footer && /*#__PURE__*/jsx(CardFooter, {
    showBorder: false,
    children: footer.map((footerItem, i) => /*#__PURE__*/jsx(ComponentFactory, {
      id: "element-".concat(footerItem === null || footerItem === void 0 ? void 0 : footerItem.id, "-").concat(i),
      element: footerItem,
      onClick: () => listActions(footerItem)
    }, "element-".concat(footerItem === null || footerItem === void 0 ? void 0 : footerItem.id, "-").concat(i)))
  });
};

const CompatsCustomDesktop = _ref => {
  let {
    listActions,
    key,
    isOpen
  } = _ref;
  const {
    state
  } = useStateValue();
  const {
    modal = {},
    config_type
  } = state;
  const {
    open_modal
  } = modal;
  const selectedVariant = generateVariant(config_type === null || config_type === void 0 ? void 0 : config_type.type, open_modal);
  const classNameCard = classNames("".concat(NAME_SPACE$5, "-card"), "".concat(NAME_SPACE$5, "-card--").concat(selectedVariant.type));
  if (!(config_type !== null && config_type !== void 0 && config_type.visible)) {
    return null;
  }
  return /*#__PURE__*/jsxs(Card, {
    paddingSize: 0,
    className: classNameCard,
    shadow: selectedVariant.shadow,
    children: [/*#__PURE__*/jsx(CardHeaderDesktop, {
      selectedVariant
    }), /*#__PURE__*/jsx(CardContentDesktop, {
      selectedVariant,
      isOpen,
      listActions
    }), /*#__PURE__*/jsx(CardFooterDesktop, {
      listActions
    })]
  }, key);
};

const COMPATS_CUSTOM = 'COMPATS_CUSTOM';

const IconFactory$1 = createIconFactory([EllipseCheckedMemo, AlertIconMemo, EllipseSearchMemo]);
const namespace$4 = 'ui-compats-header';
const EDIT_ACTION = 'EDIT_ACTION';
const CANCEL_ACTION = 'CANCEL_ACTION';
const COMPATS_MESSAGE_TOP$1 = 'COMPATS_MESSAGE_TOP';
const HeaderDesktop = _ref => {
  var _form$helpers;
  let {
    externalError = false,
    externalErrorMessage = null
  } = _ref;
  const {
    state,
    onCancelAction,
    onEditAction,
    handleStateWidgetAfterCancel,
    cleanInputs,
    deleteCompats,
    isAutoOpenModal
  } = useStateValue();
  const {
    modifier,
    actions,
    body,
    labels,
    class_name,
    left_icon,
    modal = {},
    error,
    id,
    type,
    config_type
  } = state;
  const {
    form,
    labels: formLabels,
    open_modal
  } = modal;
  const helpers = (_form$helpers = form === null || form === void 0 ? void 0 : form.helpers) !== null && _form$helpers !== void 0 ? _form$helpers : null;
  const isEmptyForm = id.indexOf('EMPTY') !== -1;
  const isPartialForm = id.indexOf('INCOMPLETE') !== -1;
  const isEmptyPartialForm = isEmptyForm || isPartialForm;
  const verticalAlignCenter = labels && labels.length === 1;
  const [isOpen, changeIsOpen] = useState(isEmptyPartialForm || open_modal);
  const [willUpdateForm, setWillUpdateForm] = useState(!isOpen && isEmptyPartialForm);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarError, setSnackBarError] = useState(false);
  const [formSelection, setFormSelection] = useState(null);
  const [key, setKey] = useState(0);
  const [messageVisible] = useState(config_type === null || config_type === void 0 ? void 0 : config_type.visible);
  const handleForm = e => {
    if (isOpen) {
      var _actions$find$track, _actions$find;
      const actionTrack = actions && ((_actions$find$track = (_actions$find = actions.find(action => action.id === CANCEL_ACTION)) === null || _actions$find === void 0 ? void 0 : _actions$find.track) !== null && _actions$find$track !== void 0 ? _actions$find$track : modal.track_close);
      if (window && window.melidata) {
        window.melidata('cleanAndSend', 'event', {
          path: actionTrack && actionTrack.melidata_event.path,
          data: updateUserSelectionTrackPost(modal, actionTrack)
        });
      }
      if (window && window.meli_ga) {
        const category = actionTrack && actionTrack.analytics_event ? actionTrack.analytics_event.category : '';
        const action = actionTrack && actionTrack.analytics_event ? actionTrack.analytics_event.action : '';
        window.meli_ga('send', 'event', category, action);
      }
      handleStateWidget(handleStateWidgetAfterCancel, cleanInputs, formSelection);
      onCancelAction();
    } else {
      const bodyActions = body !== null && body !== void 0 ? body : [];
      const actionTrack = actions ? [...actions, ...bodyActions].find(action => action.id === EDIT_ACTION).track : null;
      if (window && window.melidata) {
        window.melidata('cleanAndSend', 'event', {
          path: actionTrack && actionTrack.melidata_event.path,
          data: actionTrack && actionTrack.melidata_event.event_data
        });
      }
      if (window && window.meli_ga) {
        const category = actionTrack && actionTrack.analytics_event ? actionTrack.analytics_event.category : '';
        const action = actionTrack && actionTrack.analytics_event ? actionTrack.analytics_event.action : '';
        window.meli_ga('send', 'event', category, action);
      }
      onEditAction();
      sessionStorage.removeItem(COMPATS_MESSAGE_TOP$1);
    }
    if (e) e.preventDefault();
    changeIsOpen(!isOpen);
  };
  const onKeyDown = e => {
    if (e.type === 'keydown') {
      const code = e.charCode || e.keyCode;
      if (code === 32 || code === 13) {
        handleForm(e);
      }
    }
  };
  const buildActionButton = action => /*#__PURE__*/createElement(LabelBuilder, _objectSpread(_objectSpread({}, action), {}, {
    onClick: handleForm,
    onKeyDown: onKeyDown,
    key: "la-".concat(action.id)
  }));
  useEffect(() => {
    if (error || externalError) {
      setSnackBarError(true);
      setSnackBarMessage(error || externalErrorMessage);
      setTimeout(() => {
        setSnackBarError(false);
        setSnackBarMessage('');
      }, 3000);
    }
  }, [error, externalError, externalErrorMessage, state]);
  useEffect(() => {
    setWillUpdateForm(isOpen);
  }, [isOpen]);
  useEffect(() => {
    if (state !== null && state !== void 0 && state.completedInputs) {
      const cloneSTATE = cloneDeep(form === null || form === void 0 ? void 0 : form.components);
      setFormSelection(cloneSTATE);
    }
  }, [state === null || state === void 0 ? void 0 : state.completedInputs]);
  useEffect(() => {
    changeIsOpen(isEmptyPartialForm || open_modal);
  }, [isEmptyPartialForm, open_modal]);
  const handleDeleteCompats = action => {
    const actionTrack = action.track;
    if (actionTrack) {
      trackEvent(actionTrack);
    }
    deleteCompats();
    sessionStorage.removeItem(COMPATS_MESSAGE_TOP$1);
  };
  const handleCloseMessage = action => {
    const actionTrack = action.track;
    if (actionTrack) {
      trackEvent(actionTrack);
    }
    sessionStorage.removeItem(COMPATS_MESSAGE_TOP$1);
    const event = new StorageEvent('storage', {
      key: COMPATS_MESSAGE_TOP$1,
      newValue: 'false',
      storageArea: sessionStorage
    });
    window.dispatchEvent(event);
  };
  const handleClickRedirect = action => {
    const actionTrack = action.track;
    if (actionTrack) {
      trackEvent(actionTrack);
    }
    window.location.href = action.target.url;
  };
  const handleClickScrollQADB = action => {
    const actionTrack = action.track;
    const divElement = document.getElementById("".concat(action.target.url));
    if (divElement) {
      const textarea = divElement.querySelector('textarea[name="question"]');
      if (textarea) {
        textarea.focus();
        if (actionTrack) {
          trackEvent(actionTrack);
        }
      }
    }
  };
  const handleClickOpenWidget = action => {
    const actionTrack = action.track;
    if (actionTrack) {
      trackEvent(actionTrack);
    }
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
    sessionStorage.setItem(COMPATS_MESSAGE_TOP$1, 'true');
    const event = new StorageEvent('storage', {
      key: COMPATS_MESSAGE_TOP$1,
      newValue: 'true',
      storageArea: sessionStorage
    });
    window.dispatchEvent(event);
  };
  const listActions = action => {
    switch (action.id) {
      case 'EDIT_ACTION':
        handleForm(null);
        isAutoOpenModal(true);
        break;
      case 'REMOVE_OPTIONS':
        handleDeleteCompats(action);
        break;
      case 'CANCEL_ACTION':
        isAutoOpenModal(false);
        setKey(key + 1);
        handleForm(null);
        break;
      case 'CLOSE_ACTION':
        handleCloseMessage(action);
        break;
      case 'OPEN_WIDGET_ACTION':
        handleClickOpenWidget(action);
        break;
      case 'REDIRECT_ACTION':
        handleClickRedirect(action);
        break;
      case 'QADB_ACTION':
        handleClickScrollQADB(action);
        break;
      default:
        return null;
    }
  };
  const renderHeader = () => {
    var _left_icon$styles, _left_icon$styles2, _left_icon$styles3, _left_icon$styles4, _left_icon$styles5, _left_icon$styles6, _left_icon$styles7;
    return /*#__PURE__*/jsxs("div", {
      className: classNames(namespace$4, class_name, "".concat(namespace$4, "--").concat(id), {
        ["".concat(namespace$4, "--").concat(modifier)]: modifier
      }, {
        ["".concat(namespace$4, "__form--visible")]: isOpen
      }, {
        ["".concat(namespace$4, "__form--row")]: helpers && class_name === 'EMPTY'
      }),
      id: "compats-widget",
      children: [/*#__PURE__*/jsxs("div", {
        className: classNames("".concat(namespace$4, "__container"), {
          ["".concat(namespace$4, "__w_70")]: helpers && class_name === 'EMPTY'
        }),
        children: [/*#__PURE__*/jsxs("div", {
          className: classNames("".concat(namespace$4, "__row"), {
            'ui-compats-pb--spacing-14': helpers && class_name === 'EMPTY'
          }),
          children: [left_icon && /*#__PURE__*/jsx("figure", {
            "aria-hidden": true,
            className: classNames("".concat(namespace$4, "__column"), "".concat(namespace$4, "__column--left"), "".concat(namespace$4, "__left-icon"), {
              ["".concat(namespace$4, "__icon--color-").concat(left_icon === null || left_icon === void 0 || (_left_icon$styles = left_icon.styles) === null || _left_icon$styles === void 0 ? void 0 : _left_icon$styles.color)]: left_icon === null || left_icon === void 0 || (_left_icon$styles2 = left_icon.styles) === null || _left_icon$styles2 === void 0 ? void 0 : _left_icon$styles2.color,
              ["".concat(namespace$4, "__icon--bg-color").concat(left_icon === null || left_icon === void 0 || (_left_icon$styles3 = left_icon.styles) === null || _left_icon$styles3 === void 0 ? void 0 : _left_icon$styles3.bg_color)]: left_icon === null || left_icon === void 0 || (_left_icon$styles4 = left_icon.styles) === null || _left_icon$styles4 === void 0 ? void 0 : _left_icon$styles4.bg_color,
              ["".concat(namespace$4, "__icon--bg-color").concat(left_icon === null || left_icon === void 0 || (_left_icon$styles5 = left_icon.styles) === null || _left_icon$styles5 === void 0 ? void 0 : _left_icon$styles5.bg_color)]: left_icon === null || left_icon === void 0 || (_left_icon$styles6 = left_icon.styles) === null || _left_icon$styles6 === void 0 ? void 0 : _left_icon$styles6.bg_color
            }),
            children: left_icon.icon_id ? IconFactory$1(left_icon.icon_id, (_left_icon$styles7 = left_icon.styles) === null || _left_icon$styles7 === void 0 ? void 0 : _left_icon$styles7.color) : /*#__PURE__*/jsx(Image, {
              className: "ui-compats-icon ui-compats-icon--custom",
              src: left_icon.url,
              alt: left_icon.alt,
              preload: true,
              lazyload: "off"
            })
          }), /*#__PURE__*/jsxs("div", {
            className: classNames("".concat(namespace$4, "__column"), "".concat(namespace$4, "__column-info"), "".concat(namespace$4, "__label-container"), {
              ["".concat(namespace$4, "__vertical-align--center")]: verticalAlignCenter
            }),
            children: [/*#__PURE__*/jsxs("div", {
              className: classNames("".concat(namespace$4, "__column--left"), "".concat(namespace$4, "__column--titles")),
              style: class_name === 'COMPLETE' ? {
                width: 'calc(100% - 105px)'
              } : {
                width: '100%'
              },
              children: [labels && labels.map((label, idx) => /*#__PURE__*/jsx("span", {
                className: classNames("".concat(namespace$4, "__").concat(label.id)),
                children: /*#__PURE__*/createElement(LabelBuilder, _objectSpread(_objectSpread({}, label), {}, {
                  key: "l-".concat(label.id, "-").concat(idx)
                }))
              }, "".concat(label.id, "-").concat(idx))), formLabels && formLabels.map((label, idx) => /*#__PURE__*/jsx("span", {
                className: classNames("".concat(namespace$4, "__").concat(label.id)),
                children: /*#__PURE__*/createElement(LabelBuilder, _objectSpread(_objectSpread({}, label), {}, {
                  key: "fl-".concat(label.id, "-").concat(idx)
                }))
              }, "".concat(label.id, "-").concat(idx)))]
            }), actions && actions.length > 0 && /*#__PURE__*/jsx("div", {
              className: classNames("".concat(namespace$4, "__column--right")),
              children: /*#__PURE__*/jsx("span", {
                className: classNames("".concat(namespace$4, "__action"), {
                  ["".concat(namespace$4, "__vertical-align--center")]: verticalAlignCenter
                }),
                children: actions.map(action => {
                  let actionButton;
                  if (willUpdateForm && action.id === 'CANCEL_ACTION') {
                    actionButton = buildActionButton(action);
                  }
                  if (!willUpdateForm && action.id === 'EDIT_ACTION') {
                    actionButton = buildActionButton(action);
                  }
                  return actionButton;
                })
              })
            })]
          })]
        }), isOpen && form && /*#__PURE__*/jsx("div", {
          className: classNames("".concat(namespace$4, "__row"), {
            ["".concat(namespace$4, "__row--separator")]: !isEmptyPartialForm,
            'ui-compats-p--spacing-0': helpers && class_name === 'COMPLETE'
          }),
          children: helpers && class_name === 'COMPLETE' ? /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx("div", {
              className: classNames({
                'ui-compats-p--spacing-24': class_name === 'COMPLETE'
              }, {
                ["".concat(namespace$4, "__w_70")]: helpers && class_name === 'COMPLETE'
              }),
              children: /*#__PURE__*/jsx(FormDesktop, {
                form: form,
                stateEmpty: isEmpty,
                formLabels: formLabels
              })
            }), /*#__PURE__*/jsx("div", {
              className: "".concat(namespace$4, "__container_image ui-compats-bg-color-ANDES-BG-SECONDARY"),
              children: /*#__PURE__*/jsx(HelpersBuilder, {
                helpers: form.helpers,
                selectedDropdown: state === null || state === void 0 ? void 0 : state.selectedDropdown
              })
            })]
          }) : /*#__PURE__*/jsx(FormDesktop, {
            form: form,
            stateEmpty: isEmpty,
            formLabels: formLabels
          })
        })]
      }), class_name === 'EMPTY' && helpers && /*#__PURE__*/jsx("div", {
        className: "".concat(namespace$4, "__container_image ui-compats-bg-color-ANDES-BG-SECONDARY"),
        children: /*#__PURE__*/jsx(HelpersBuilder, {
          helpers: form.helpers,
          selectedDropdown: state === null || state === void 0 ? void 0 : state.selectedDropdown
        })
      }), snackBarError && /*#__PURE__*/jsx(Snackbar, {
        "data-testid": "snackbar",
        message: snackBarMessage,
        color: "red",
        show: snackBarError,
        delay: 3000
      })]
    });
  };
  if (type === 'COMPATS_MESSAGE') {
    var _config_type$actions_, _config_type$color, _config_type$color2, _config_type$hierarch;
    const primary = isOpen ? null : actions === null || actions === void 0 ? void 0 : actions.find(action => {
      var _action$message_type;
      return ((_action$message_type = action.message_type) === null || _action$message_type === void 0 ? void 0 : _action$message_type.toUpperCase()) === 'PRIMARY';
    });
    const secondary = isOpen ? null : actions === null || actions === void 0 ? void 0 : actions.find(action => {
      var _action$message_type2;
      return ((_action$message_type2 = action.message_type) === null || _action$message_type2 === void 0 ? void 0 : _action$message_type2.toUpperCase()) === 'SECONDARY';
    });
    const close = actions === null || actions === void 0 ? void 0 : actions.find(action => {
      var _action$message_type3;
      return ((_action$message_type3 = action.message_type) === null || _action$message_type3 === void 0 ? void 0 : _action$message_type3.toUpperCase()) === 'CLOSE';
    });
    const showIcon = typeof (config_type === null || config_type === void 0 ? void 0 : config_type.icon_completed) === 'undefined' ? true : config_type.icon_completed;
    return /*#__PURE__*/jsx("div", {
      className: classNames("".concat(namespace$4, "__container-message"), {
        ["".concat(namespace$4, "__message-action-full")]: (config_type === null || config_type === void 0 ? void 0 : config_type.button_position) === 'FULL'
      }, {
        ["".concat(namespace$4, "__form--row")]: helpers && isOpen
      }),
      children: /*#__PURE__*/jsxs(Message, {
        actions_position: config_type === null || config_type === void 0 || (_config_type$actions_ = config_type.actions_position) === null || _config_type$actions_ === void 0 ? void 0 : _config_type$actions_.toLowerCase(),
        color: open_modal ? config_type === null || config_type === void 0 || (_config_type$color = config_type.color2) === null || _config_type$color === void 0 ? void 0 : _config_type$color.toLowerCase() : config_type === null || config_type === void 0 || (_config_type$color2 = config_type.color) === null || _config_type$color2 === void 0 ? void 0 : _config_type$color2.toLowerCase(),
        closable: isOpen && (config_type === null || config_type === void 0 ? void 0 : config_type.closeable),
        visible: messageVisible,
        hierarchy: config_type === null || config_type === void 0 || (_config_type$hierarch = config_type.hierarchy) === null || _config_type$hierarch === void 0 ? void 0 : _config_type$hierarch.toLowerCase(),
        onClose: () => {
          if (close) {
            listActions(close);
          } else {
            setKey(key + 1);
          }
        },
        thumbnail: left_icon && (open_modal || showIcon) && /*#__PURE__*/jsx(Image, {
          className: "ui-compats-icon ui-compats-icon--custom",
          src: left_icon.url,
          alt: left_icon.alt,
          preload: true,
          lazyload: "off"
        }),
        actions: /*#__PURE__*/jsx(MessageActions, {
          primary: {
            onClick: () => {
              listActions(primary);
            },
            text: primary === null || primary === void 0 ? void 0 : primary.text
          },
          secondary: {
            onClick: () => {
              listActions(secondary);
            },
            text: secondary === null || secondary === void 0 ? void 0 : secondary.text
          }
        }),
        children: [/*#__PURE__*/jsxs("div", {
          className: classNames({
            ["".concat(namespace$4, "__w_70")]: helpers && isOpen
          }),
          children: [(config_type === null || config_type === void 0 ? void 0 : config_type.subtitle) && /*#__PURE__*/jsx("p", {
            children: config_type === null || config_type === void 0 ? void 0 : config_type.subtitle
          }), !open_modal && labels && /*#__PURE__*/jsx(RowLabelMobile, {
            labels: labels,
            namespace: namespace$4,
            actions: actions && actions.filter(action => !action.message_type),
            listActions: listActions
          }, "RLM-".concat(type)), open_modal && formLabels && formLabels.map((label, idx) => /*#__PURE__*/jsx("span", {
            className: classNames("".concat(namespace$4, "__").concat(label.id)),
            children: /*#__PURE__*/createElement(LabelBuilder, _objectSpread(_objectSpread({}, label), {}, {
              key: "fl-".concat(label.id, "-").concat(idx)
            }))
          }, "".concat(label.id, "-").concat(idx))), isOpen && form && /*#__PURE__*/jsx("div", {
            className: classNames("".concat(namespace$4, "__message-form"), {
              ["".concat(namespace$4, "__message-no-icon")]: !left_icon
            }, "".concat(namespace$4, "--").concat(id), {
              ["".concat(namespace$4, "__form--row")]: helpers && isOpen
            }),
            children: /*#__PURE__*/jsx(FormDesktop, {
              form: form,
              stateEmpty: isEmpty,
              formLabels: formLabels
            })
          })]
        }), isOpen && helpers && /*#__PURE__*/jsx("div", {
          className: "".concat(namespace$4, "__container_image ui-compats-bg-color-ANDES-BG-SECONDARY"),
          children: /*#__PURE__*/jsx(HelpersBuilder, {
            helpers: form.helpers,
            selectedDropdown: state === null || state === void 0 ? void 0 : state.selectedDropdown
          })
        })]
      })
    }, key);
  }
  if (type === COMPATS_CUSTOM) {
    return /*#__PURE__*/jsx(CompatsCustomDesktop, {
      listActions: listActions,
      isOpen: isOpen
    }, key);
  }
  return renderHeader();
};

const COOKIE_NAME$1 = 'compats-bottomsheet';
const EXPIRATION_TIME$1 = 365;
const DEFAULT_ATTRS$1 = {
  path: '/'
};
const CoachMarks = _ref => {
  let {
    locale = {},
    steps = [],
    isMobile = false,
    time = 150,
    disableScrolling = true,
    disableParentScroll = true,
    disableScrollParentFix = true,
    spotlightClicks = false
  } = _ref;
  const [isRun, setIsRun] = React.useState(false);
  const {
    state: {
      modal: {
        form
      }
    }
  } = useStateValue();
  React.useEffect(() => {
    const timeout = setTimeout(() => {
      setIsRun(true);
    }, time);
    return () => clearTimeout(timeout);
  }, []);
  const onChange = _ref2 => {
    let {
      status
    } = _ref2;
    if (['finished'].includes(status) && isRun) {
      var _coachMarkCookie$view, _coachMarkCookie;
      setIsRun(false);
      const coachMarkCookie = getCookie(COOKIE_NAME$1);
      let counter = coachMarkCookie ? (_coachMarkCookie$view = (_coachMarkCookie = coachMarkCookie["".concat(COOKIE_NAME$1)]["coachmark_open_counter-".concat(form.domain_id)]) === null || _coachMarkCookie === void 0 ? void 0 : _coachMarkCookie.view_count) !== null && _coachMarkCookie$view !== void 0 ? _coachMarkCookie$view : 0 : 0;
      counter += 1;
      const cookieValue = coachMarkCookie ? _objectSpread(_objectSpread({}, coachMarkCookie["".concat(COOKIE_NAME$1)][0]), {}, {
        ["coachmark_open_counter-".concat(form.domain_id)]: {
          view_count: counter
        }
      }) : {
        ["coachmark_open_counter-".concat(form.domain_id)]: {
          view_count: counter
        }
      };
      setCookie(COOKIE_NAME$1, cookieValue, _objectSpread(_objectSpread({}, DEFAULT_ATTRS$1), {}, {
        expires: getExpiration(EXPIRATION_TIME$1)
      }));
    }
  };
  return /*#__PURE__*/jsx(AndesCoachMark, {
    run: isRun,
    steps: steps,
    callback: onChange,
    locale: locale,
    isMobile: isMobile,
    disableParentScroll: disableParentScroll,
    disableScrolling: disableScrolling,
    disableScrollParentFix: disableScrollParentFix,
    spotlightClicks: spotlightClicks
  });
};

const _excluded$1 = ["onSubmitForm", "onRemove"];
const MainDesktop = _ref => {
  var _initialState$modal;
  let {
      onSubmitForm = async () => {},
      onRemove = async () => {}
    } = _ref,
    initialState = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/jsxs(StateProvider, {
    onSubmitForm: onSubmitForm,
    onRemove: onRemove,
    initialState: _objectSpread({}, initialState),
    children: [/*#__PURE__*/jsx(HeaderDesktop, {
      externalError: !!initialState.error,
      externalErrorMessage: initialState === null || initialState === void 0 || (_initialState$modal = initialState.modal) === null || _initialState$modal === void 0 || (_initialState$modal = _initialState$modal.form) === null || _initialState$modal === void 0 ? void 0 : _initialState$modal.error_message
    }), initialState.coachmark && /*#__PURE__*/jsx(CoachMarks, _objectSpread({}, initialState.coachmark))]
  });
};
MainDesktop.displayName = 'MainDesktop';

const FooterHeader = _ref => {
  var _footer$labels, _footer$labels2, _footer$labels3;
  let {
    footer,
    namespace
  } = _ref;
  if ((footer === null || footer === void 0 || (_footer$labels = footer.labels) === null || _footer$labels === void 0 ? void 0 : _footer$labels.length) < 1) return null;
  return /*#__PURE__*/jsx("footer", {
    className: "".concat(namespace, "__footer"),
    children: (footer === null || footer === void 0 || (_footer$labels2 = footer.labels) === null || _footer$labels2 === void 0 ? void 0 : _footer$labels2.length) > 0 && (footer === null || footer === void 0 || (_footer$labels3 = footer.labels) === null || _footer$labels3 === void 0 ? void 0 : _footer$labels3.map(labelItem => /*#__PURE__*/jsx(LabelBuilder, _objectSpread({}, labelItem))))
  });
};

const namespace$3 = 'ui-compats';
const FormMobile = _ref => {
  let {
    form = null,
    formLabels = null,
    stateEmpty = true,
    handleChangeState = () => {}
  } = _ref;
  const {
    state
  } = useStateValue();
  const {
    method,
    path,
    target,
    components,
    actions,
    helpers,
    class_name,
    orientation_actions
  } = form;
  return /*#__PURE__*/jsxs(AndesForm, {
    className: classNames("".concat(namespace$3, "__form-container"), {
      ["".concat(namespace$3, "__actions-flex")]: orientation_actions === 'HORIZONTAL',
      [class_name]: class_name
    }),
    method: method,
    action: path,
    target: target,
    "data-testid": "form",
    children: [/*#__PURE__*/jsxs("div", {
      className: classNames("".concat(namespace$3, "__labels-container"), {
        ["".concat(namespace$3, "__inputs-container--with-rows")]: !stateEmpty
      }),
      children: [formLabels && (formLabels === null || formLabels === void 0 ? void 0 : formLabels.map((label, index) => label.id !== 'TITLE' && label.id !== 'TITLE_MODAL' && /*#__PURE__*/createElement(LabelBuilder, _objectSpread(_objectSpread({}, label), {}, {
        key: "fl-".concat(index)
      })))), helpers && /*#__PURE__*/jsx(HelpersBuilder, {
        helpers: helpers,
        selectedDropdown: state === null || state === void 0 ? void 0 : state.selectedDropdown
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: classNames("".concat(namespace$3, "__inputs-container"), {
        ["".concat(namespace$3, "__inputs-container--with-rows")]: !stateEmpty
      }),
      children: [components && /*#__PURE__*/jsx("div", {
        className: classNames("".concat(namespace$3, "__inputs"), {
          ["".concat(namespace$3, "__row")]: !stateEmpty
        }),
        children: components.map(component => /*#__PURE__*/jsx(React.Fragment, {
          children: /*#__PURE__*/jsx(ComponentFactory$1, _objectSpread({}, component))
        }, component.id))
      }), actions && /*#__PURE__*/jsx("div", {
        className: classNames("".concat(namespace$3, "__actions"), {
          ["".concat(namespace$3, "__row")]: !stateEmpty
        }),
        children: actions.map(action => /*#__PURE__*/jsx(React.Fragment, {
          children: /*#__PURE__*/jsx(ButtonComp, {
            id: action.action_id,
            size: action.size,
            hierarchy: action.hierarchy,
            disabled: !action.is_enable,
            text: action.text,
            shouldEnableButton: action.action_id === 'remove_options' || (state === null || state === void 0 ? void 0 : state.completedInputs),
            handleChangeState: handleChangeState
          })
        }, action.action_id))
      })]
    })]
  });
};

const namespace$2 = 'ui-compats-icon ui-compats-icon--close';
const CloseIcon = _ref => {
  let {
    className = null
  } = _ref;
  return /*#__PURE__*/jsx("svg", {
    className: classNames(namespace$2, className),
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/jsx("path", {
      d: "M-0.00109005 1.26599L6.00235 7.26943L-0.00109005 13.2729L1.05957 14.3335L7.06301 8.33009L13.0596 14.3267L14.1202 13.266L8.12367 7.26943L14.1202 1.27286L13.0596 0.212203L7.06301 6.20877L1.05957 0.20533L-0.00109005 1.26599Z",
      fill: "black"
    })
  });
};
var CloseIcon$1 = /*#__PURE__*/React.memo(CloseIcon);

const namespace$1 = 'ml-compats--modal';
const COOKIE_NAME = 'compats-bottomsheet';
const EXPIRATION_TIME = 365;
const DEFAULT_ATTRS = {
  path: '/'
};
const ModalForm = _ref => {
  var _state$modal5;
  let {
    title = null,
    form = null,
    formLabels = null,
    handleForm = null,
    attrs = DEFAULT_ATTRS
  } = _ref;
  const {
    state: {
      isOpenForm
    },
    bottomSheetAction,
    isAutoOpenModal,
    state
  } = useStateValue();
  const closeBottomSheet = () => {
    if (isOpenForm) {
      handleForm();
    }
    bottomSheetAction(false);
  };
  const handleChangeState = () => {
    bottomSheetAction(false);
  };
  useEffect(() => {
    var _state$modal;
    if (state !== null && state !== void 0 && (_state$modal = state.modal) !== null && _state$modal !== void 0 && _state$modal.open_modal) {
      var _state$modal2;
      bottomSheetAction(true);
      if (state !== null && state !== void 0 && (_state$modal2 = state.modal) !== null && _state$modal2 !== void 0 && _state$modal2.track_force_modal) {
        var _state$modal3;
        trackEvent(state === null || state === void 0 || (_state$modal3 = state.modal) === null || _state$modal3 === void 0 ? void 0 : _state$modal3.track_force_modal);
      }
    }
  }, []);
  useEffect(() => {
    var _state$modal4;
    if (state !== null && state !== void 0 && (_state$modal4 = state.modal) !== null && _state$modal4 !== void 0 && _state$modal4.open_modal) {
      var _modalCookie$view_cou, _modalCookie;
      const modalCookie = getCookie(COOKIE_NAME);
      let counter = modalCookie ? (_modalCookie$view_cou = (_modalCookie = modalCookie["".concat(COOKIE_NAME)]["modal_open_counter-".concat(form.domain_id)]) === null || _modalCookie === void 0 ? void 0 : _modalCookie.view_count) !== null && _modalCookie$view_cou !== void 0 ? _modalCookie$view_cou : 0 : 0;
      if (isOpenForm) {
        counter += 1;
        isAutoOpenModal(false);
      }
      const cookieValue = modalCookie ? _objectSpread(_objectSpread({}, modalCookie["".concat(COOKIE_NAME)][0]), {}, {
        ["modal_open_counter-".concat(form.domain_id)]: {
          view_count: counter
        }
      }) : {
        ["modal_open_counter-".concat(form.domain_id)]: {
          view_count: counter
        }
      };
      setCookie(COOKIE_NAME, cookieValue, _objectSpread(_objectSpread({}, attrs), {}, {
        expires: getExpiration(EXPIRATION_TIME)
      }));
    }
  }, [isOpenForm]);
  return /*#__PURE__*/jsxs(Modal$1, {
    className: namespace$1,
    title: title,
    open: isOpenForm,
    maxHeight: "90vh",
    onClose: bottomSheetAction,
    fixedAction: true,
    type: namespace$1,
    closable: false,
    children: [/*#__PURE__*/jsx(FormMobile, {
      form: form,
      formLabels: formLabels,
      stateEmpty: isEmpty,
      isMobileView: true,
      handleChangeState: handleChangeState
    }), (state === null || state === void 0 || (_state$modal5 = state.modal) === null || _state$modal5 === void 0 ? void 0 : _state$modal5.enable_close) !== false && /*#__PURE__*/jsx("button", {
      type: "button",
      onClick: closeBottomSheet,
      "aria-label": "close",
      role: "button",
      "data-testid": "button-sheet-close",
      className: "".concat(namespace$1, "__icon"),
      children: /*#__PURE__*/jsx(CloseIcon$1, {})
    })]
  });
};

function fromEntries(iterable) {
  return Array.from(iterable).reduce((obj, _ref) => {
    let [key, val] = _ref;
    obj[key] = val;
    return obj;
  }, {});
}

const CardHeaderMobile = _ref => {
  let {
    selectedVariant
  } = _ref;
  const {
    state
  } = useStateValue();
  const {
    header
  } = state;
  const classNameCardHeader = classNames("".concat(NAME_SPACE$5, "-card__header"), "".concat(NAME_SPACE$5, "-card__header--").concat(selectedVariant.type));
  const classNamePill = classNames("".concat(NAME_SPACE$5, "-card__header-badge"), "".concat(NAME_SPACE$5, "-card__header-badge--").concat(selectedVariant.type));
  return header && /*#__PURE__*/jsx(CardHeader, {
    className: classNameCardHeader,
    showBorder: false,
    children: /*#__PURE__*/jsx("div", {
      children: header === null || header === void 0 ? void 0 : header.map((headerItem, i) => /*#__PURE__*/jsx(ComponentFactory, {
        element: headerItem,
        color: selectedVariant.color,
        classNamePill: classNamePill,
        id: "element-".concat(headerItem === null || headerItem === void 0 ? void 0 : headerItem.id, "-").concat(i)
      }, "element-".concat(headerItem === null || headerItem === void 0 ? void 0 : headerItem.id, "-").concat(i)))
    })
  });
};

const CardContentMobile = _ref => {
  var _modal$labels;
  let {
    selectedVariant,
    handleForm,
    listActions
  } = _ref;
  const {
    state
  } = useStateValue();
  const {
    left_icon,
    modal,
    body
  } = state;
  const title = modal === null || modal === void 0 || (_modal$labels = modal.labels) === null || _modal$labels === void 0 ? void 0 : _modal$labels.find(label => label.id === TITLE || label.id === TITLE_MODAL);
  const classNameCardContent = classNames("".concat(NAME_SPACE$5, "-card__content"), "".concat(NAME_SPACE$5, "-card__content--").concat(selectedVariant.type));
  const classNameDetailsIcon = classNames("".concat(NAME_SPACE$5, "-card__content-details-icon"), "".concat(NAME_SPACE$5, "-card__content-details-icon--").concat(selectedVariant.type));
  return /*#__PURE__*/jsx(CardContent, {
    children: /*#__PURE__*/jsxs("div", {
      className: classNameCardContent,
      children: [/*#__PURE__*/jsx("div", {
        className: "".concat(NAME_SPACE$5, "-card__content--column"),
        children: /*#__PURE__*/jsxs("div", {
          className: "".concat(NAME_SPACE$5, "-card__content-details"),
          children: [/*#__PURE__*/jsx(Image, {
            className: classNameDetailsIcon,
            src: left_icon.url,
            alt: left_icon.alt,
            preload: true,
            lazyload: "off"
          }), /*#__PURE__*/jsx("div", {
            children: body === null || body === void 0 ? void 0 : body.map((element, i) => {
              var _element$id;
              return /*#__PURE__*/jsx(ComponentFactory, {
                id: "element-".concat(element === null || element === void 0 || (_element$id = element.id) === null || _element$id === void 0 ? void 0 : _element$id.toLowerCase(), "-").concat(i),
                element: element,
                onClick: () => {
                  listActions(element);
                }
              }, "element-".concat(element === null || element === void 0 ? void 0 : element.id, "-").concat(i));
            })
          })]
        })
      }), /*#__PURE__*/jsx(ModalForm, {
        title: title === null || title === void 0 ? void 0 : title.text,
        form: modal === null || modal === void 0 ? void 0 : modal.form,
        formLabels: modal === null || modal === void 0 ? void 0 : modal.labels,
        handleForm: handleForm
      })]
    })
  });
};

const CardFooterMobile = _ref => {
  let {
    listActions
  } = _ref;
  const {
    state
  } = useStateValue();
  const {
    footer
  } = state;
  return footer && /*#__PURE__*/jsx(CardFooter, {
    className: "".concat(NAME_SPACE$5, "-card__footer"),
    showBorder: false,
    children: footer.map((footerItem, i) => {
      var _footerItem$id, _footerItem$id2;
      return /*#__PURE__*/jsx(ComponentFactory, {
        element: footerItem,
        onClick: () => listActions(footerItem),
        id: "element-".concat(footerItem === null || footerItem === void 0 || (_footerItem$id = footerItem.id) === null || _footerItem$id === void 0 ? void 0 : _footerItem$id.toLowerCase(), "-").concat(i),
        platform: MOBILE
      }, "element-".concat(footerItem === null || footerItem === void 0 || (_footerItem$id2 = footerItem.id) === null || _footerItem$id2 === void 0 ? void 0 : _footerItem$id2.toLowerCase(), "-").concat(i));
    })
  });
};

const CompatsCustomMobile = _ref => {
  let {
    listActions,
    handleForm
  } = _ref;
  const {
    state
  } = useStateValue();
  const {
    config_type
  } = state;
  const selectedVariant = generateVariant(config_type === null || config_type === void 0 ? void 0 : config_type.type);
  const classNameCard = classNames("".concat(NAME_SPACE$5, "-card"), "".concat(NAME_SPACE$5, "-card--").concat(selectedVariant.type));
  if (!(config_type !== null && config_type !== void 0 && config_type.visible)) {
    return null;
  }
  return /*#__PURE__*/jsxs(Card, {
    paddingSize: 0,
    className: classNameCard,
    shadow: "outline",
    children: [/*#__PURE__*/jsx(CardHeaderMobile, {
      selectedVariant
    }), /*#__PURE__*/jsx(CardContentMobile, {
      selectedVariant,
      handleForm,
      listActions
    }), /*#__PURE__*/jsx(CardFooterMobile, {
      listActions
    })]
  });
};

const IconFactory = createIconFactory([EllipseCheckedMemo, AlertIconMemo, EllipseSearchMemo]);
const namespace = 'ui-compats-header';
const COMPATS_MESSAGE_TOP = 'COMPATS_MESSAGE_TOP';
const HeaderMobile = _ref => {
  var _modal$labels;
  let {
    externalError = false,
    externalErrorMessage = null
  } = _ref;
  const {
    state,
    bottomSheetAction,
    onCancelAction,
    onEditAction,
    handleStateWidgetAfterCancel,
    cleanInputs
  } = useStateValue();
  const {
    modifier,
    type,
    actions,
    labels,
    class_name,
    left_icon,
    modal,
    error,
    footer,
    isOpenForm,
    config_type
  } = state;
  const title = modal === null || modal === void 0 || (_modal$labels = modal.labels) === null || _modal$labels === void 0 ? void 0 : _modal$labels.find(label => label.id === 'TITLE' || label.id === 'TITLE_MODAL');
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarError, setSnackBarError] = useState(false);
  const [formSelection, setFormSelection] = useState(null);
  const firstValue = 1;
  const EDIT_ACTION = 'EDIT_ACTION';
  useEffect(() => {
    if (error || externalError) {
      setSnackBarError(true);
      setSnackBarMessage(error || externalErrorMessage);
    }
  }, [error, externalError, externalErrorMessage, state]);
  const handleForm = action => {
    if (isOpenForm) {
      const actionTrack = modal.track_close;
      const data = updateUserSelectionTrackPost(modal, actionTrack);
      const asArray = data ? Object.entries(data.user_selection).filter(enteries => enteries[firstValue]) : null;
      if (asArray) {
        const count_selection = String(asArray.length);
        const toObj = fromEntries(asArray);
        const updateData = _objectSpread(_objectSpread({}, data), {}, {
          user_selection: toObj,
          completion_qty: count_selection
        });
        if (window && window.melidata) {
          window.melidata('cleanAndSend', 'event', {
            path: actionTrack && actionTrack.melidata_event.path,
            data: updateData
          });
        }
      }
      if (window && window.meli_ga) {
        const category = actionTrack && actionTrack.analytics_event ? actionTrack.analytics_event.category : '';
        const trackAction = actionTrack && actionTrack.analytics_event ? actionTrack.analytics_event.action : '';
        window.meli_ga('send', 'event', category, trackAction);
      }
      handleStateWidget(handleStateWidgetAfterCancel, cleanInputs, formSelection);
      onCancelAction();
    } else {
      var _actions$find;
      const trackActionOpen = actions === null || actions === void 0 || (_actions$find = actions.find(actionEvent => actionEvent.id === EDIT_ACTION)) === null || _actions$find === void 0 ? void 0 : _actions$find.track;
      const actionOpen = trackActionOpen !== null && trackActionOpen !== void 0 ? trackActionOpen : action === null || action === void 0 ? void 0 : action.track;
      if (window && window.melidata) {
        window.melidata('cleanAndSend', 'event', {
          path: actionOpen && actionOpen.melidata_event.path,
          data: actionOpen && actionOpen.melidata_event.event_data
        });
      }
      if (window && window.meli_ga) {
        const category = actionOpen && actionOpen.analytics_event ? actionOpen.analytics_event.category : '';
        const trackAction = actionOpen && actionOpen.analytics_event ? actionOpen.analytics_event.action : '';
        window.meli_ga('send', 'event', category, trackAction);
      }
      onEditAction();
    }
  };
  const handleClick = (e, action) => {
    if (e) e.stopPropagation();
    if (!isOpenForm) {
      handleForm(action);
      bottomSheetAction(true);
    }
  };
  const handleClickRedirect = action => {
    const actionTrack = action.track;
    if (actionTrack) {
      trackEvent(actionTrack);
    }
    window.location.href = action.target.url;
  };
  const handleClickScrollQADB = action => {
    const actionTrack = action.track;
    const divElement = document.getElementById("".concat(action.target.url));
    if (divElement) {
      const textarea = divElement.querySelector('textarea[name="question"]');
      if (textarea) {
        textarea.focus();
        if ('ontouchstart' in window) {
          textarea.click();
        }
        if (actionTrack) {
          trackEvent(actionTrack);
        }
      }
    }
  };
  const handleClickOpenWidget = action => {
    const actionTrack = action.track;
    if (actionTrack) {
      trackEvent(actionTrack);
    }
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
    sessionStorage.setItem(COMPATS_MESSAGE_TOP, 'true');
    const event = new StorageEvent('storage', {
      key: COMPATS_MESSAGE_TOP,
      newValue: 'true',
      storageArea: sessionStorage
    });
    window.dispatchEvent(event);
  };
  useEffect(() => {
    if (state !== null && state !== void 0 && state.completedInputs) {
      var _modal$form;
      const cloneSTATE = cloneDeep(modal === null || modal === void 0 || (_modal$form = modal.form) === null || _modal$form === void 0 ? void 0 : _modal$form.components);
      setFormSelection(cloneSTATE);
    }
  }, [state === null || state === void 0 ? void 0 : state.completedInputs]);
  const listActions = action => {
    switch (action.id) {
      case 'EDIT_ACTION':
        handleClick(null, action);
        break;
      case 'OPEN_WIDGET_ACTION':
        handleClickOpenWidget(action);
        break;
      case 'REDIRECT_ACTION':
        handleClickRedirect(action);
        break;
      case 'QADB_ACTION':
        handleClickScrollQADB(action);
        break;
      default:
        return null;
    }
  };
  const renderHeader = () => {
    var _left_icon$styles, _left_icon$styles2, _left_icon$styles3, _left_icon$styles4, _left_icon$styles5;
    return /*#__PURE__*/jsxs("div", {
      className: classNames(namespace, "".concat(namespace, "--").concat(class_name), {
        ["".concat(namespace, "--").concat(type)]: type
      }, {
        ["".concat(namespace, "--").concat(modifier)]: modifier
      }, {
        ["".concat(namespace, "__row--separator")]: isOpenForm
      }),
      onClick: handleClick,
      role: "button",
      "aria-pressed": "false",
      "data-testid": "form",
      tabIndex: 0,
      id: "compats-widget",
      children: [/*#__PURE__*/jsxs("div", {
        className: "".concat(namespace, "__container"),
        children: [/*#__PURE__*/jsx("figure", {
          "aria-hidden": true,
          className: classNames("".concat(namespace, "__box"), "".concat(namespace, "__box--left"), {
            ["".concat(namespace, "__icon--color-").concat(left_icon === null || left_icon === void 0 || (_left_icon$styles = left_icon.styles) === null || _left_icon$styles === void 0 ? void 0 : _left_icon$styles.color)]: left_icon === null || left_icon === void 0 || (_left_icon$styles2 = left_icon.styles) === null || _left_icon$styles2 === void 0 ? void 0 : _left_icon$styles2.color,
            ["".concat(namespace, "__icon--bg-color").concat(left_icon === null || left_icon === void 0 || (_left_icon$styles3 = left_icon.styles) === null || _left_icon$styles3 === void 0 ? void 0 : _left_icon$styles3.bg_color)]: left_icon === null || left_icon === void 0 || (_left_icon$styles4 = left_icon.styles) === null || _left_icon$styles4 === void 0 ? void 0 : _left_icon$styles4.bg_color
          }),
          children: left_icon.icon_id ? IconFactory(left_icon.icon_id, (_left_icon$styles5 = left_icon.styles) === null || _left_icon$styles5 === void 0 ? void 0 : _left_icon$styles5.color) : /*#__PURE__*/jsx(Image, {
            className: "ui-compats-icon ui-compats-icon--custom",
            src: left_icon.url,
            alt: left_icon.alt,
            preload: true,
            lazyload: "off"
          })
        }), /*#__PURE__*/jsx("div", {
          className: classNames("".concat(namespace, "__box"), "".concat(namespace, "__box--right")),
          children: /*#__PURE__*/jsx(RowLabelMobile, {
            labels: labels,
            namespace: namespace,
            actions: actions,
            handleClick: handleClick
          }, "RLM-".concat(type))
        }), /*#__PURE__*/jsx(ModalForm, {
          title: title === null || title === void 0 ? void 0 : title.text,
          form: modal === null || modal === void 0 ? void 0 : modal.form,
          formLabels: modal === null || modal === void 0 ? void 0 : modal.labels,
          handleForm: handleForm
        })]
      }), /*#__PURE__*/jsx(FooterHeader, {
        footer: footer,
        namespace: namespace
      }), snackBarError && /*#__PURE__*/jsx(Snackbar, {
        "data-testid": "snackbar",
        message: snackBarMessage,
        color: "red",
        show: snackBarError,
        delay: 3000
      })]
    });
  };
  if (type === 'COMPATS_MESSAGE') {
    var _config_type$actions_, _config_type$color, _config_type$hierarch;
    const primary = actions.find(action => {
      var _action$message_type;
      return ((_action$message_type = action.message_type) === null || _action$message_type === void 0 ? void 0 : _action$message_type.toUpperCase()) === 'PRIMARY';
    });
    const secondary = actions.find(action => {
      var _action$message_type2;
      return ((_action$message_type2 = action.message_type) === null || _action$message_type2 === void 0 ? void 0 : _action$message_type2.toUpperCase()) === 'SECONDARY';
    });
    return /*#__PURE__*/jsxs("div", {
      className: classNames("".concat(namespace, "__container-message"), {
        ["".concat(namespace, "__message-action-full")]: (config_type === null || config_type === void 0 ? void 0 : config_type.button_position) === 'FULL'
      }),
      children: [/*#__PURE__*/jsxs(Message, {
        actions_position: (_config_type$actions_ = config_type.actions_position) === null || _config_type$actions_ === void 0 ? void 0 : _config_type$actions_.toLowerCase(),
        color: (_config_type$color = config_type.color) === null || _config_type$color === void 0 ? void 0 : _config_type$color.toLowerCase(),
        closeable: config_type.closeable,
        hierarchy: (_config_type$hierarch = config_type.hierarchy) === null || _config_type$hierarch === void 0 ? void 0 : _config_type$hierarch.toLowerCase(),
        thumbnail: left_icon && /*#__PURE__*/jsx(Image, {
          className: "ui-compats-icon ui-compats-icon--custom",
          src: left_icon.url,
          alt: left_icon.alt,
          preload: true,
          lazyload: "off"
        }),
        actions: /*#__PURE__*/jsx(MessageActions, {
          primary: {
            onClick: () => {
              listActions(primary);
            },
            text: primary === null || primary === void 0 ? void 0 : primary.text
          },
          secondary: {
            onClick: () => {
              listActions(secondary);
            },
            text: secondary === null || secondary === void 0 ? void 0 : secondary.text
          }
        }),
        children: [config_type.subtitle && /*#__PURE__*/jsx("p", {
          children: config_type.subtitle
        }), /*#__PURE__*/jsx(RowLabelMobile, {
          labels: labels,
          namespace: namespace,
          actions: actions.filter(action => !action.message_type),
          listActions: listActions
        }, "RLM-".concat(type))]
      }), /*#__PURE__*/jsx(ModalForm, {
        title: title === null || title === void 0 ? void 0 : title.text,
        form: modal === null || modal === void 0 ? void 0 : modal.form,
        formLabels: modal === null || modal === void 0 ? void 0 : modal.labels,
        handleForm: handleForm
      }), /*#__PURE__*/jsx(FooterHeader, {
        footer: footer,
        namespace: namespace
      }), snackBarError && /*#__PURE__*/jsx(Snackbar, {
        "data-testid": "snackbar",
        message: snackBarMessage,
        color: "red",
        show: snackBarError,
        delay: 3000
      })]
    });
  }
  if (type === COMPATS_CUSTOM) {
    return /*#__PURE__*/jsx(CompatsCustomMobile, {
      listActions: listActions,
      handleForm: handleForm
    });
  }
  return renderHeader();
};

const _excluded = ["onSubmitForm", "onRemove"];
const MainMobile = _ref => {
  var _initialState$modal;
  let {
      onSubmitForm = async () => {},
      onRemove = async () => {}
    } = _ref,
    initialState = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(StateProvider, {
    initialState: _objectSpread({}, initialState),
    onSubmitForm: onSubmitForm,
    onRemove: onRemove,
    isMobile: true,
    children: [/*#__PURE__*/jsx(HeaderMobile, {
      externalError: !!initialState.error,
      externalErrorMessage: initialState === null || initialState === void 0 || (_initialState$modal = initialState.modal) === null || _initialState$modal === void 0 || (_initialState$modal = _initialState$modal.form) === null || _initialState$modal === void 0 ? void 0 : _initialState$modal.error_message
    }), initialState.coachmark && /*#__PURE__*/jsx(CoachMarks, _objectSpread(_objectSpread({}, initialState.coachmark), {}, {
      isMobile: true
    }))]
  });
};
MainMobile.displayName = 'MainMobile';

export { MainDesktop as CompatsDesktop, MainMobile as CompatsMobile };
